import React, { Component } from 'react'
import {
    GET_IDEA_URL, GET_METADATA, REPLICABILITYOPTIONS, X_POLLINATION_CAMPAIGN, ACCESS_TOKEN, USER_DATA, OTHER_REGIONS, DISPLAYPROJECTTHEME, YESORNO, SOLUTIONCOMPLEXITY, AIFIRST, AI_DOC_LINK,
    IMPACTOPTIONS,
    NO_VD,
    VD_TO_CLIENT,
    VD_TO_GENPACT,
    VD_TO_CLIENT_PLUS_GENPACT,
    IMPACT_TO_CLIENT,
    IMPACT_TO_GENPACT, GENAIOPTIONS, PPT_CONTENT,
    IDEA_ADMIN_UPDATE, REVIEW_IDEA_URL, CANCEL,
    COMPLETE_STATUS,
    REJECTED
} from '../assets/constants/constants';
import Toast from 'light-toast';
import Select from 'react-select';
import { selectValidation as selectStyle, textBoxValidation } from "../utils/FieldValidation";
import ValueDelivery from '../utils/ValueDelivery';

export class AdminEditPage extends Component {
    sessionData = JSON.parse(localStorage.getItem(USER_DATA));
    accessToken = localStorage.getItem(ACCESS_TOKEN);

    constructor(props) {
        super(props)
        let propsData = this.props.location;
        this.state = {
            selectStyle: {},
            ideaItem: {},
            propsData: propsData,

            showCommentLog: false,
            commentLog: false,

            accountList: [],
            accountSelectedOption: [],
            HoldingAccount: "",
            regionList: [],
            regionSelectedOption: null,
            subRegionList: [],
            subRegionSelectedOption: null,
            countryList: [],
            countrySelectedOption: null,
            verticalList: [],
            verticalSelectedOption: null,
            subVerticalList: [],
            subVerticalSelectedOption: null,
            Unit: "",
            Segment: "",
            serviceLineList: [],
            serviceLineSelectedOption: null,
            subServiceLineSelectedOption: null,
            unitsAndSegmentsList: [],
            Problem: "",
            Solution: "",

            campaignList: [],
            campaignSelectedOption: null,
            subCampaignList: [],
            subCampaignOption: null,
            campaignUnionQuery: null,
            displaySubCampaign: false,
            dataBridgeProjectThemeList: [],
            dataBridgeProjectSelectedOption: null,
            displayProjectTheme: false,
            campaignInsight: "",

            rolesList: [],
            blackBeltSelectedOption: null,
            mbbSelectedOption: null,
            LDTLeadSelectedOption: null,

            certificationLevelsList: [],
            certLevelsSelectedOption: null,
            certificationWorkTypeList: [],
            certWorkTypeSelectedOption: null,
            transformationLeversList: [],
            transSelectedOption: null,
            digitalProjectTypeList: [],
            digitalProjectTypeSelectedOptions: null,
            methodologyList: [],
            methodologySelectedOptions: null,
            OtherTools: "",

            replicaIndex: null,
            IsBestInClass: false,
            IsZeroImpactProject: false,
            IsSharedToSixSigma: false,

            base64File1: "",
            base64File2: "",
            base64File1: "",
            base64File2: "",
            base64File3: "",
            base64File4: "",
            filename1: "",
            filename2: "",
            filename3: "",
            filename4: "",
            fileType1: "",
            fileType2: "",
            fileType3: "",
            fileType4: "",
            golFpnaFileDetails: [],

            businessImpactValueArray: [],
            summaryArray: [],
            FinalImpactFTE: 0.0,
            FinalImpactDollar: 0.0,

            showHrefModal: false,

            showClientFields: false,
            showGOLFields: false,
            showClientApprovalFields: false,

            golFilename: "",
            golContent: "",
            golFileType: "",
            golOhr: "",
            golEmail: "",
            golFullname: "",

            fpnaFilename: "",
            fpnaContent: "",
            fpnaFileType: "",
            fpnaName: "",
            fpnaEmail: "",
            fpnaOhr: "",

            clientName: "",
            clientRole: "",
            clientSignOffDate: "",
            clientApprovalEmailSelectedOption: null,
            clientApprovalEmailSelectedOptionObj: null,
            signOffFilename: "",
            signOffFileType: "",


            monetizableProjectSelectedOption: null,


            SowID: "",
            IsVDMonetizable: [],

            FPnAOHRMonetization: "",
            FPnANameMonetization: "",
            FPnAEmailMonetization: "",
            FPnAFileNameMonetization: "",
            FPnAFileTypeMonetization: "",
            FPnAFileMonetization: "",

            qcImpactTagChangeSelected: [],
            qcDeliveryCategorizedSelect: [],
            deliveryComputedCorrectlySelected: [],
            signOffDeliverySelected: [],

            impactOptionSelected: [],

            biThreshold: "",
            vrconditiontype: "",
            vrMapping: "",
            vrRegionMapping: "",

            isFpnaRequired: false,

            clusterData: [],
            isClusterSaveDisabled: true,
            displayParentAlpha: '',
            projectTypeSelectedOption: null,
            projectIDSelectedOption: null,

            // AI First states starts here
            IsIdeaReplicableSelectedOption: [],
            solutionFeasibleSelectedOption: [],
            solutionComplexitySelectedOption: [],
            isAISelectedOption: null,
            AIBRD: "",
            AIReason: "",


            //LDT approval
            displayLDTCommentLog: false,
            LDTLogs: [],

            RecType: "",
            DPA: [],

            files_can_be_deleted: [
                {
                    value: 0,
                    label: 'GOL Approval Document'
                },
                {
                    value: 1,
                    label: 'FP&NA Approval Document'
                },
            ],

            qcComments: [],
            qcCommentLog: false,
            QCOHR: "",
            qcCommentsWithVD: [],

            NewOrReplicatedIdea: false,
            replicationIDValidated: false,

          

            showCancelIdeaModal:false,

            cancelComment:""

        }
    }

    async componentDidMount() {
        await this.fetchIdea();
        await this.fetchMetadata();

    }

    formatDateString(dateparam) {
        return dateparam.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    }

    formatDateStringWithTime(dateparam) {
        return dateparam.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }

    fetchIdea = async () => {
        try {
            Toast.loading("Fetching Idea & Metadata...", () => { });
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                }
            };
            const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    console.log("fetch idea", data)
                    Toast.hide()
                    
                    this.setState({
                        ideaItem: data.ResultSets.Table1[0],
                        HoldingAccount: data.ResultSets.Table1[0].HoldingAccount,
                        Problem: data.ResultSets.Table1[0].Problem,
                        Solution: data.ResultSets.Table1[0].Solution,

                        OwnerOHR: data.ResultSets.Table1[0].OwnerOHR,
                        OwnerName: data.ResultSets.Table1[0].OwnerName,

                        commentLog: data.AllLogs ? data.AllLogs : [],

                        signOffFilename: data.ResultSets.Table1[0].CustomerSignoffFileName,
                        signOffFileType: data.ResultSets.Table1[0].CustomerSignoffType,


                        FinalImpactFTE: data.ResultSets.Table1[0].FinalImpactFTE,
                        FinalImpactDollar: data.ResultSets.Table1[0].FinalImpactDollar,

                        clientName: data ? data.ResultSets.Table1[0].CustName : null,
                        clientRole: data ? data.ResultSets.Table1[0].CustDesgn : null,
                        clientSignOffDate: data.ResultSets.Table1[0].CustSignOffDate ? new Date(data.ResultSets.Table1[0].CustSignOffDate).toLocaleDateString('en-CA').split('/').reverse().join('-') : null,

                        golOhr: data ? data.ResultSets.Table1[0].GOLOHR : "",
                        golFullname: data ? data.ResultSets.Table1[0].GOLName : null,
                        fpnaOhr: data ? data.ResultSets.Table1[0].FPnAOHR : null,
                        fpnaName: data ? data.ResultSets.Table1[0].FPnAName : null,

                        golFilename: data.ResultSets.Table1[0].GOLFileName,
                        golFileType: data.ResultSets.Table1[0].GOLFileType,
                        fpnaFileType: data.ResultSets.Table1[0].FPnAFileType,
                        fpnaName: data.ResultSets.Table1[0].FPnAFileName,

                        clientApprovalEmailSelectedOption: data.ResultSets.Table1[0].IsClientApprovalAttached,

                        IsVDMonetizable: data.ResultSets.Table1[0].IsVDMonetizable,

                        FPnAFileNameMonetization: data.ResultSets.Table1[0].FPnAFileNameMonetization ? data.ResultSets.Table1[0].FPnAFileNameMonetization : "",
                        FPnAOHRMonetization: data.ResultSets.Table1[0].FPnAOHRMonetization,
                        FPnANameMonetization: data.ResultSets.Table1[0].FPnANameMonetization,
                        SowID: data.ResultSets.Table1[0].SowID,

                        clusterData: data.ClusterData ? data.ClusterData : [],

                        // AI First
                        isAI: data.ResultSets.Table1[0].isAI,
                        IsIdeaReplicableSelectedOption: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0].IsIdeaReplicable : "" : "",
                        solutionFeasibleSelectedOption: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0].IsSolnFeasible : "" : "",
                        solutionComplexitySelectedOption: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0].SolnComplexity : "" : "",
                        AIBRD: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0].LinkBRD : "" : "",
                        AIReason: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0].AIReason : "" : "",

                        //LDT
                        LDTLogs: data.LDTLogs ? data.LDTLogs : [],

                        OtherTools: data.ResultSets.Table1[0].OtherTools,
                        CodersTable: data.CodersTable ? data.CodersTable ? data.CodersTable : [] : [],
                        olderCoderTable: data.CodersTable ? data.CodersTable ? data.CodersTable : [] : [],

                        campaignUnionQuery: data.CampaignDetails.ResultSets.Table1,

                        QCOHR: data.ResultSets.Table1[0].QCOHR,
                        qcComments: data.QcComments ? data.QcComments : [],
                        qcCommentsWithVD: data.qcCommentsWithVD ? data.qcCommentsWithVD : [],


                        NewOrReplicatedIdea: data.ResultSets.Table1[0].NewOrReplicatedIdea,
                        IsSharedToSixSigma: data.ResultSets.Table1[0].IsSharedToSixSigma,

                        vdForComponent: data.BIData ? data.BIData : [],

                        

                    }, () => {

                        if (this.state.qcComments.length > 0) {
                            var keys = Object.keys(this.state.qcComments);
                            var last = keys[keys.length - 1];
                            let varFinalLastComment = this.state.qcComments[last].Comment;
                            this.setState({ lastQCCOmment: varFinalLastComment }, () => {
                                // console.log("last comment for qc=>",this.state.lastQCCOmment);
                            });
                        }

                        if (this.state.campaignUnionQuery) {
                            let filteredUnionQuery = this.state.campaignUnionQuery.filter((item) => {
                                return item.CampaignID === this.state.ideaItem.CampaignID
                            })
                            if (filteredUnionQuery) {
                                if (filteredUnionQuery[0]) {
                                    this.setState({
                                        campaignInsight: filteredUnionQuery[0].CampaignDescr,
                                        campaignSelectedOption: {
                                            value: filteredUnionQuery[0].CampaignID,
                                            label: filteredUnionQuery[0].Campaign,
                                        },
                                    }, () => { }
                                    );
                                }
                            }

                            // from fetch idea if campaign is selected as genai then display genai sub campaign from genai local options or else choose from the union query
                            if (this.state.ideaItem.CampaignName === "Gen AI") {
                                GENAIOPTIONS.map((item) => {
                                    if (item.label === this.state.ideaItem.SubCampaignName) {
                                        this.setState({
                                            subCampaignOption: item,
                                            displaySubCampaign: true
                                        }, () => {

                                        });
                                    }
                                });
                            } else {
                                // from union query - 
                                let options = [];
                                let result = [];
                                this.state.campaignUnionQuery.map((item) => {
                                    if (this.state.ideaItem.CampaignID === item.CampaignID) {
                                        if (item.SubCampaign) {
                                            options.push({ value: item.SubCampaignID, label: item.SubCampaign });
                                        }
                                    }
                                    return true;
                                });
                                result = options.reduce((unique, index) => {
                                    if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                                        unique.push(index);
                                    }
                                    return unique;
                                }, []);
                                if (result.length > 0) {
                                    this.setState({ displaySubCampaign: true }, () => { })
                                    result.map((item) => {
                                        if (this.state.ideaItem.SubCampaignID === item.value) {
                                            this.setState({ subCampaignOption: item });
                                        }
                                    })
                                }
                            }
                        }

                        if (this.state.ideaItem.ReplicabilityIndex) {
                            REPLICABILITYOPTIONS.map((item) => {
                                if (item.value === this.state.ideaItem.ReplicabilityIndex) {
                                    this.setState({ replicaIndex: { label: item.label, value: item.value } }, () => { })
                                }
                            })
                        }

                        if (this.state.LDTLogs.length > 0) {
                            let LDTPostData = [];
                            this.state.LDTLogs.map((item, index) => {
                                if (item.IsQBR) {
                                    let localData = [...this.state.LDTLogs];
                                    localData[index].IsQBR = {
                                        value: 0,
                                        label: localData[index].IsQBR,
                                    };
                                    LDTPostData = localData;
                                }
                            });
                            this.setState({ LDTLogs: LDTPostData }, () => { })
                        }

                        if (this.state.isAI) {
                            YESORNO.map((item) => {
                                if (item.label.toLowerCase() === this.state.isAI.toLowerCase()) {
                                    this.setState({ isAISelectedOption: item, }, () => { });
                                }
                            })
                        }

                        if (this.state.IsIdeaReplicableSelectedOption === 0 || this.state.IsIdeaReplicableSelectedOption === 1 ||
                            this.state.IsIdeaReplicableSelectedOption === false
                            || this.state.IsIdeaReplicableSelectedOption === true
                        ) {
                            if (this.state.IsIdeaReplicableSelectedOption === 0 || this.state.IsIdeaReplicableSelectedOption === "0" || this.state.IsIdeaReplicableSelectedOption === false) {
                                this.setState({
                                    IsIdeaReplicableSelectedOption: {
                                        value: 0,
                                        label: "No",
                                    },
                                }, () => { });
                            }
                            if (this.state.IsIdeaReplicableSelectedOption === 1 || this.state.IsIdeaReplicableSelectedOption === "1" || this.state.IsIdeaReplicableSelectedOption === true) {
                                this.setState({
                                    IsIdeaReplicableSelectedOption: {
                                        value: 0,
                                        label: "Yes",
                                    },
                                }, () => { });
                            }
                        }



                        this.state.solutionComplexitySelectedOption && SOLUTIONCOMPLEXITY.map((item, index) => {
                            if (item.label === this.state.solutionComplexitySelectedOption) {
                                this.setState({
                                    solutionComplexitySelectedOption: {
                                        value: item.value,
                                        label: item.label,
                                    },
                                }, () => { });
                            }
                        })


                        if (this.state.solutionFeasibleSelectedOption === 0 || this.state.solutionFeasibleSelectedOption === 1
                            || this.state.solutionFeasibleSelectedOption === false
                            || this.state.solutionFeasibleSelectedOption === true
                        ) {
                            if (this.state.solutionFeasibleSelectedOption === 0 || this.state.solutionFeasibleSelectedOption === "0" || this.state.solutionFeasibleSelectedOption === false) {
                                this.setState({
                                    solutionFeasibleSelectedOption: {
                                        value: 0,
                                        label: "No",
                                    },
                                }, () => { });
                            }
                            if (this.state.solutionFeasibleSelectedOption === 1 || this.state.solutionFeasibleSelectedOption === "1" || this.state.solutionFeasibleSelectedOption === true) {
                                this.setState({
                                    solutionFeasibleSelectedOption: {
                                        value: 0,
                                        label: "Yes",
                                    },
                                }, () => { });
                            }
                        }

                        if (this.state.clusterData && this.state.clusterData.length > 0) {
                            const targetRecID = this.state.ideaItem.LeanID;
                            const filteredData = this.state.clusterData.filter(item => item.RecAlpha === targetRecID);

                            if (filteredData && filteredData.length > 0 && filteredData !== undefined && filteredData !== null) {
                                this.setState({ displayParentAlpha: filteredData[0].ParentAlpha }, () => { })
                                let options = [];
                                options.push({ value: 0, label: filteredData[0].ParentAlpha })
                                this.setState({ projectIDSelectedOption: options }, () => { })

                                let options1 = [];
                                options1.push({ value: 0, label: "GB" })
                                this.setState({ projectTypeSelectedOption: options1 }, () => { })
                            } else {
                                this.setState({ displayParentAlpha: "" }, () => { })
                            }
                        } else {
                            this.setState({ displayParentAlpha: "" }, () => { })
                        }

                        if (this.state.ideaItem.CreatedDate) {
                            let created = new Date(this.state.ideaItem.CreatedDate);
                            let abc = new Date(DISPLAYPROJECTTHEME);
                            if (created.getTime() < abc.getTime()) {

                                this.setState({ displayProjectTheme: true })
                            } else {
                                this.setState({ displayProjectTheme: false })

                            }
                        }

                        YESORNO.map(item => {
                            if (item.label === this.state.IsVDMonetizable) {
                                this.setState({ IsVDMonetizable: item }, () => { })
                            }
                            if (item.label === this.state.ideaItem.IsVDImpactTagged) {
                                this.setState({ qcImpactTagChangeSelected: item }, () => { })
                            }
                            if (item.label === this.state.ideaItem.IsVDCategorized) {
                                this.setState({ qcDeliveryCategorizedSelect: item }, () => { })
                            }
                            if (item.label === this.state.ideaItem.IsVDComputed) {
                                this.setState({ deliveryComputedCorrectlySelected: item }, () => { })
                            }
                            if (item.label === this.state.ideaItem.IsVDClientSignOff) {
                                this.setState({ signOffDeliverySelected: item }, () => { })
                            }
                            if (item.label === this.state.bbReview) {
                                this.setState({ bbReview: item }, () => { })
                            }

                        })
                        IMPACTOPTIONS.map((item) => {
                            if (item.label === this.state.ideaItem.VDType) {
                                this.setState({ impactOptionSelected: item })
                            }
                        })
                    });
                }
            }
        }
        catch (error) {
            Toast.hide()
            console.log("error =>", error)
            Toast.fail("Error while fetching idea. Please try again!", 3000, () => { });
        }
    }

    fetchMetadata = async () => {
        try {
            const param = {
                EntityType: "",
                EntityName: ""
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };
            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    this.setState({
                        businessImpactMasterList: data ? data.BIMasterDataVerseNew : [],
                        accountList: data ? data.Accounts.sort((a, b) => { return a.ACCOUNT > b.ACCOUNT ? 1 : -1; }) : [],

                        campaignList: data ? data.Campaigns : [],
                        subCampaignList: data ? data.SubCampaigns : [],
                        dataBridgeProjectThemeList: data ? data.DataBridgeThemes : [],

                        serviceLineList: data ? data.ServiceLines : [],
                        countryList: data ? data.Countries.sort((a, b) => { return a.COUNTRY > b.COUNTRY ? 1 : -1; }) : [],

                        certificationLevelsList: data ? data.CertificationLevels : [],
                        certificationWorkTypeList: data ? data.WorkType : [],
                        transformationLeversList: data ? data.TransformationLevers : [],
                        digitalProjectTypeList: data ? data.DigitalProjectTypes : [],
                        aiClassificationList: data ? data.AIClassification : [],
                        methodologyList: data ? data.Methodologies : [],

                        biThreshold: data.BIQCThreshold ? data.BIQCThreshold[0] ? data.BIQCThreshold[0].pg_threshold : 0 : 0,
                        vrconditiontype: data.BIQCVRMapping ? data.BIQCVRMapping[0] ? data.BIQCVRMapping[0].pg_vrconditiontype : [] : [],
                        vrVerticalMapping: data.BIQCVRMapping ? data.BIQCVRMapping[0] ? data.BIQCVRMapping[0].pg_vertical ? data.BIQCVRMapping[0].pg_vertical.split("|") : "ALL" : "ALL" : "ALL",
                        vrRegionMapping: data.BIQCVRMapping ? data.BIQCVRMapping[0] ? data.BIQCVRMapping[0].pg_region ? data.BIQCVRMapping[0].pg_region.split("|") : "ALL" : "ALL" : "ALL",
                 
                  

                    }, () => {
                        
                        
                        this.setSelectedOptions();
                    })
                }
            }
        } catch (error) {
            console.log(JSON.stringify(error));
            Toast.fail('Error occured while getting metadata idea. Please try again!', 3000, () => { });
        }
    }

    setSelectedOptions = () => {
        if (this.state.ideaItem.AccountManual) {
            this.state.accountList && this.state.accountList.map((item, index) => {
                if (this.state.ideaItem.AccountManual === item.ACCOUNT) {
                    this.setState({
                        accountSelectedOption: {
                            label: item.ACCOUNT,
                            value: index
                        },
                    }, () => {
                        this.fetchVerticalOptions();
                    })
                }
            });
        }


        this.state.countryList.map((item, index) => {
            if (this.state.ideaItem.Country === item.COUNTRY) {
                this.setState({
                    countrySelectedOption: { label: item.COUNTRY, value: index },
                }, () => {
                    this.fetchRegionOptions();
                })
            }
            return 1;
        });

        if (this.state.ideaItem.DataBridgeTheme) {
            this.state.dataBridgeProjectThemeList.map((item) => {
                if (this.state.ideaItem.DataBridgeTheme === item.DBProjectThemeName) {
                    this.setState({ dataBridgeProjectSelectedOption: { value: item.ThemeId, label: item.DBProjectThemeName } }, () => { })
                }
            });
        }

        this.state.serviceLineList.map((item) => {
            if (this.state.ideaItem.ServiceLineName === item.ServiceLineName) {
                this.setState({
                    serviceLineSelectedOption: {
                        value: item.ServiceLineId,
                        label: item.ServiceLineName
                    }
                }, () => { })
            }
            if (this.state.ideaItem.SubServiceLine === item.SubServiceLineName) {
                this.setState({
                    subServiceLineSelectedOption: {
                        value: item.SubServiceLineId,
                        label: item.SubServiceLineName
                    }
                })
            }
            return 1;
        });


        if (this.state.ideaItem.BlackBeltUserId) {
            this.setState({
                blackBeltSelectedOption: {
                    value: this.state.ideaItem.BlackBeltUserId,
                    label: this.state.ideaItem.BlackBeltUserName
                },
            })
        }
        if (this.state.ideaItem.MBBOHR) {
            this.setState({
                mbbSelectedOption: {
                    value: this.state.ideaItem.MBBOHR,
                    label: this.state.ideaItem.MBBName
                },

            })
        }

        this.state.certificationLevelsList.map((item) => {
            if (this.state.ideaItem.CertificationLevelName === item.CertificationLevelName) {
                this.setState({
                    certLevelsSelectedOption: {
                        value: item.CertificationLevelId,
                        label: item.CertificationLevelName
                    }
                })
            }
            return 1;
        });

        this.state.certificationWorkTypeList.map((item) => {
            if (this.state.ideaItem.CertificationWorkTypeName === item.WorkTypeName) {
                this.setState({
                    certLevelsSelectedOption: {
                        value: 0,
                        label: item.WorkTypeName
                    }
                })
            }
            return 1;
        });

        this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
            if (this.state.ideaItem.TLID === item.TLID) {
                this.setState({
                    transSelectedOption: {
                        value: item.TLID,
                        label: item.TransformationLever,
                    },
                }, () => {
                    this.setToolsMethodologies()
                    if (this.state.transSelectedOption && this.state.transSelectedOption.label === "Digital") {
                        this.setState({ digitalProjectEnabled: true }, () => { })
                    }
                });
            }
            return 1;
        });

        if (this.state.ideaItem.DigitalProjectType) {
            this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
                if (item.DPTypeID === this.state.ideaItem.DPTypeID) {
                    this.setState({ digitalProjectTypeSelectedOptions: { value: item.DPTypeID, label: item.DPType }, digitalProjectEnabled: true })
                }
                this.setToolsMethodologies()
            })
        }


        this.state.aiClassificationList && this.state.aiClassificationList.map((item) => {
            if (this.state.ideaItem.AIClassification === item.AIClassification) {
                this.setState({
                    aiClassificationListSelectedOption: {
                        value: item.RecID,
                        label: item.AIClassification,
                    },
                }, () => {
                    this.setToolsMethodologies()
                });
            }
            return 1;
        });


        if (this.state.ideaItem) {
            this.setState({
                ReplicationProjectId: this.state.ideaItem.ReplicationProjectId,
                IsBestInClass: this.state.ideaItem.IsBestInClass,
                IsZeroImpactProject: this.state.ideaItem.IsZeroImpactProject,
                LDTLeadSelectedOption: { label: this.state.ideaItem.LDTLeadName, value: this.state.ideaItem.LDTId }
            })
        }
    }

    renderAccountOptions = () => {
        let options = [];
        let accountName = "";
        this.state.accountList.map((item) => {
            accountName = item.ACCOUNT.toString().toLowerCase();
            if (!(accountName.startsWith("unidentified") || accountName.startsWith("unmapped") || accountName.startsWith("genpact"))) {
                options.push({
                    value: item.ACCOUNT_L2,
                    label: item.ACCOUNT
                })
            }
            return true;
        });
        return options;
    }

    renderVerticalOptions = () => {
        let options = [];
        const uniqueVerticals = [...new Map(this.state.verticalList.map(item => [item["VERTICAL"], item])).values()]
        uniqueVerticals.map((item) => {
            if (!(item.VERTICAL.toString().toLowerCase() === "ts")) {
                options.push({ value: item.VERTICAL, label: item.VERTICAL });
            }
            return true;
        });
        return options;
    }

    renderSubVerticalOptions = () => {
        let options = [];
        this.state.verticalList.map((item, index) => {
            if (this.state.verticalSelectedOption?.label === item.VERTICAL) {
                if (item.SUB_VERTICAL.toString().toLowerCase() !== "corporate" || this.state.accountSelectedOption?.label.toLowerCase().includes("support")) {
                    options.push({ value: index, label: item.SUB_VERTICAL });
                }
            }
            return true;
        });

        return options;
    }

    renderBlackBeltOptions = () => {
        let options = [];
        let result = [];
        this.state.rolesList.map((item) => {
            const userRole = JSON.parse(item.pg_Role).pg_role;
            if (userRole === "BB" || userRole === "QA") {
                if (this.state.ownerOHR !== item.pg_ohr) {
                    options.push({ value: item.pg_ohr, label: item.pg_username });
                }
            }
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);
        return result
    }

    renderMBBOptions = () => {
        let options = [];
        let result = [];
        this.state.rolesList.map((item) => {
            const userRole = JSON.parse(item.pg_Role).pg_role;
            if (userRole === "MBB") {
                if (this.state.ownerOHR !== item.pg_ohr) {
                    options.push({ value: item.pg_ohr, label: item.pg_username });
                }
            }
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);
        return result
    }
    renderLeadOptions = () => {
        let options = [];
        const uniqueLeadList = [...new Map(this.state.rolesList.map(item => [item.pg_ohr, item])).values()];
        uniqueLeadList.map((item) => {
            options.push({ value: item.pg_ohr, label: item.pg_username });
            return options;
        });
        return options;
    }



    renderRegionOptions = () => {
        let options = [];
        if (this.state.regionList.length > 0) {
            this.state.regionList.map((item) => {
                options.push({ value: item.Region, label: item.Region });
                return true;
            });
        }
        return options;
    }
    renderSubRegionOptions = () => {
        let options = [];
        if (this.state.subRegionList.length > 0) {
            this.state.subRegionList.map((item) => {
                options.push({ value: item.Region, label: item.Region });
                return true;
            });
        }
        return options;
    }

    renderCountryOptions = () => {
        let options = [];
        this.state.countryList.map((item) => {
            options.push({ value: item.COUNTRY, label: item.COUNTRY });
            return true;
        });
        return options;
    }



    renderDataBridgeProjectThemeOptions = (e) => {
        let options = [];
        this.state.dataBridgeProjectThemeList.map((item) => {
            options.push({ value: item.ThemeId, label: item.DBProjectThemeName });
            return true;
        });
        return options;
    }

    renderServiceLineOptions = () => {
        let options = [];
        const uniqueServiceLineList = [...new Map(this.state.serviceLineList.map(item =>
            [item.ServiceLineName, item])).values()];
        uniqueServiceLineList.map((item) => {
            options.push({ value: item.ServiceLineId, label: item.ServiceLineName });
            return true;
        });
        return options;
    }

    renderSubServiceLineOptions = () => {
        let options = [];
        this.state.serviceLineList && this.state.serviceLineList.map((item) => {
            if (this.state.serviceLineSelectedOption && this.state.serviceLineSelectedOption.label === item.ServiceLineName) {
                options.push({ value: item.SubServiceLineId, label: item.SubServiceLineName });
                return true;
            }
            return true;
        });
        return options;
    }



    replicaIndexChangeHandler = (e) => {
        this.setState({
            replicaIndex: {
                value: e.value,
                label: e.label
            }
        });
    }

    handleAccountNameChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.accountSelectedOption = selectStyle(true);
        this.setState({
            accountSelectedOption: { label: e.label, value: 0 },
            Unit: "",
            Segment: "",
            verticalList: [],
            verticalSelectedOption: null,
            subVerticalSelectedOption: null,
            regionSelectedOption: null,
            subRegionSelectedOption: null,
            countrySelectedOption: null,
            blackBeltSelectedOption: null,
            mbbSelectedOption: null,
            HoldingAccount: e.value,
            selectStyle: styleStateObj,
        }, () => {
            this.fetchVerticalOptions();
            this.fetchCountryOptions();
        }, () => {
            this.renderVerticalOptions();
            this.renderCountryOptions();
        });
    }

    handleVerticalChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.verticalSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            verticalSelectedOption: {
                value: e.value,
                label: e.label
            }
        }, () => {
            this.state.verticalList && this.state.verticalList.map((item, index) => {
                if (item.VERTICAL === e.label) {
                    this.setState({
                        subVerticalSelectedOption: {
                            value: index,
                            label: item.SUB_VERTICAL
                        }
                    })
                }
            })
            let localUnit = "";
            let localSegment = "";
            this.state.unitsAndSegmentsList && this.state.unitsAndSegmentsList.map((item) => {
                if (!(item.VERTICAL.toString().toLowerCase() === "ts")) {
                    if (e && e.label === item.VERTICAL) {
                        if (item) {
                            localUnit = item.UNIT;
                            localSegment = item.SEGMENT;
                        }
                    }
                }
            })
            this.setState({ Unit: localUnit, Segment: localSegment }, () => { })
            this.renderSubVerticalOptions();
            this.fetchRoles();
        });
    }

    handleSubVerticalChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.subVerticalSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            subVerticalSelectedOption: {
                value: e.value,
                label: e.label
            }
        });
    }

    handleBBChange = (e) => {
        if ((parseInt(e.value) === parseInt(this.state.OwnerOHR)) || (parseInt(e.value) === parseInt(this.state.ideaItem.CreatorOHR))) {
            Toast.fail('Mentor user cannot be the same as Idea Owner/Requester. Please select a different Mentor user.', 3000, () => {
                return;
            });
            return;
        }
        let styleStateObj = this.state.selectStyle;
        styleStateObj.blackBeltSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            blackBeltSelectedOption: {
                value: e.value,
                label: e.label
            },
        }, () => {
            console.log("black belt selected option is =>", this.state.blackBeltSelectedOption)
        });
    }

    handleMBBChange = (e) => {
        if ((parseInt(e.value) === parseInt(this.state.OwnerOHR)) || (parseInt(e.value) === parseInt(this.state.ideaItem.CreatorOHR))) {
            Toast.fail('MBB user cannot be the same as Idea Owner/Requester. Please select a different Mentor user.', 3000, () => {
                return;
            });
            return;
        }
        let styleStateObj = this.state.selectStyle;
        styleStateObj.mbbSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            mbbSelectedOption: {
                value: e.value,
                label: e.label
            },

        });
    }

    handleLDTLeadOptionChange = (e) => {
        if ((parseInt(e.value) === parseInt(this.state.OwnerOHR)) || (parseInt(e.value) === parseInt(this.state.ideaItem.CreatorOHR))) {
            Toast.fail('LDT user cannot be the same as Idea Owner/Requester. Please select a different LDT user.', 3000, () => {
                return;
            });
            return;
        }
        this.setState({ LDTLeadSelectedOption: e }, () => { })
    }

    handleRegionChange = (e) => {
        if (e.label === OTHER_REGIONS && (!this.state.verticalSelectedOption || this.state.verticalSelectedOption?.label === "")) {
            this.setState({
                regionSelectedOption: null
            });
            Toast.fail('Please select Account & Vertical to fetch BlackBelt users for Other Regions.', 3000, () => {
                return;
            });
        } else {
            let styleStateObj = this.state.selectStyle;
            styleStateObj.regionSelectedOption = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj,

                regionSelectedOption: {
                    value: e.value,
                    label: e.label
                },
                blackBeltSelectedOption: null,
                mbbSelectedOption: null,
            }, () => {
                this.fetchRoles(e);
            });
        }
    }

    handleSubRegionChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.subRegionSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            subRegionSelectedOption: {
                value: e.value,
                label: e.label
            }
        });
    }

    handleCountryChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.countrySelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            regionSelectedOption: null,
            subRegionSelectedOption: null,
            blackBeltSelectedOption: null,
            mbbSelectedOption: null,
            countrySelectedOption: {
                value: e.value,
                label: e.label
            }
        }, () => {
            this.fetchRegionOptions(e);
        });
    }

    handleServiceLineChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.serviceLineSelectedOption = selectStyle(true);
        this.setState({
            subServiceLineSelectedOption: null,
            serviceLineSelectedOption: {
                value: e.value,
                label: e.label
            },
            selectStyle: styleStateObj,
        });
    }

    handleSubServiceLineChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.subServiceLineSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            subServiceLineSelectedOption: {
                value: e.value,
                label: e.label
            },
            selectStyle: styleStateObj,
        });
    }

    handleProblemChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        let nonWhiteSpace = e.replace(/^\s+|\s+$/gm, '');;
        styleStateObj.Problem = textBoxValidation(true);
        if (nonWhiteSpace.length < 2000) {
            this.setState({
                Problem: e,
                selectStyle: styleStateObj,
            }, () => {
                this.state.Problem.replace(/'/g, "\\'");
            });
        } else {
            const trimmedValue = nonWhiteSpace.slice(0, 2000);
            this.setState({
                Problem: trimmedValue,
                selectStyle: styleStateObj,
            }, () => {
                this.state.Problem.replace(/'/g, "\\'");
            });
        }
    }

    handleSolutionChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        let nonWhiteSpace = e.replace(/^\s+|\s+$/gm, '');;
        if (nonWhiteSpace.length < 2000) {
            styleStateObj.Solution = textBoxValidation(true);
            this.setState({
                Solution: e,
                selectStyle: styleStateObj,
            }, () => {
                this.state.Solution.replace(/'/g, "\\'");
            });
        } else {
            const trimmedValue = nonWhiteSpace.slice(0, 2000);
            this.setState({
                Solution: trimmedValue,
                selectStyle: styleStateObj,
            }, () => {
                this.state.Solution.replace(/'/g, "\\'");
            });
        }
    }

    renderCampaignOptions = () => {
        let options = [];
        let result = [];
        let filteredData = this.state.campaignUnionQuery && this.state.campaignUnionQuery.filter((item) => { return item.Campaign !== "AI First" })
        filteredData && filteredData.map((item) => {
            options.push({ value: item.CampaignID, label: item.Campaign, SOrd: item.CampaignOrd });
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);
        result.sort((a, b) => a.SOrd - b.SOrd)
        return result
    };

    handleCampaignChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.campaignSelectedOption = selectStyle(true);
        this.setState({
            IsIdeaReplicableSelectedOption: [],
            solutionFeasibleSelectedOption: [],
            solutionComplexitySelectedOption: [],
            dataBridgeProjectSelectedOption: null,
            subCampaignOption: null,
            selectStyle: styleStateObj,
            campaignSelectedOption: e,
            transSelectedOption: null,
            aiClassificationListSelectedOption: null,
            methodologySelectedOptions: null,
            digitalProjectTypeSelectedOptions: null,
            OtherTools: "",
        }, () => { });

        // below code will check the union query and will set subcampaign to true if the union query contains the subcampaign query
        let options = [];
        let result = [];
        this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
            if (e.value === item.CampaignID) {
                this.setState({ campaignInsight: item.CampaignDescr }, () => { })
                if (item.SubCampaign) {
                    options.push({ value: item.SubCampaignID, label: item.SubCampaign });
                }
            }
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);

        if (result.length > 0) {
            this.setState({ displaySubCampaign: true }, () => { })
        } else {
            this.setState({ displaySubCampaign: false }, () => { })
        }

    };

    renderSubCampaignOptions = () => {
        if (this.state.campaignSelectedOption?.label === "Gen AI") {
            return GENAIOPTIONS;
        } else {
            let options = [];
            let result = [];
            this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
                if (this.state.campaignSelectedOption?.value === item.CampaignID) {
                    options.push({ value: item.SubCampaignID, label: item.SubCampaign, SOrd: item.SubCampaignOrd });
                }
                return true;
            });
            result = options.reduce((unique, index) => {
                if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                    unique.push(index);
                }
                return unique;
            }, []);
            result.sort((a, b) => a.SOrd - b.SOrd)
            return result
        }
    };

    handleSubCampaignChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.subCampaignOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            subCampaignOption: e,
        }, () => { });
    };

    showHideDiv = () => {
        this.setState({ NewOrReplicatedIdea: !this.state.NewOrReplicatedIdea, ReplicationProjectId: "", replicationIDValidated: false }, () => { });
    }

    showHideBestInClass = () => {
        this.setState({ IsBestInClass: !this.state.IsBestInClass });
    }

    showHideIsSharedToSixSigma = () => {
        this.setState({ IsSharedToSixSigma: !this.state.IsSharedToSixSigma }, () => { })
    }

    handleReplicationIdChange = (text) => {
        this.setState({ ReplicationProjectId: text });
    }

    validateReplicationId = () => {
        this.fetchReplicationIdeaDetails(this.state.ReplicationProjectId)
    }

    fetchReplicationIdeaDetails = (IdeaId) => {
        let replicaID = IdeaId;
        if (IdeaId.length > 7) {
            replicaID = IdeaId.slice(2, 11)
        }
        if (IdeaId && IdeaId.length === 9 && IdeaId.startsWith("I-")) {
            if (replicaID && replicaID.length === 7) {

                Toast.loading("Fetching Replication Idea Details. Please wait...", () => { });
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": "Bearer " + this.accessToken,
                    }
                };
                return fetch(`${GET_IDEA_URL}IdeaId=${replicaID}&case=data&casetype=fetchIdeaDetails`, requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        console.log("data after verification =>", data)
                        if (data.ResultSets.Table1 === undefined) {
                            Toast.fail("We could not find Idea details based on the entered Idea ID. Please check and reenter.", 5000, () => { });
                            let styleStateObj = this.state.selectStyle;
                            styleStateObj.ReplicationProjectId = textBoxValidation(false);
                            this.setState({ replicationIDValidated: false, selectStyle: styleStateObj, }, () => { });
                            return false;
                        } else {
                            let styleStateObj = this.state.selectStyle;
                            styleStateObj.ReplicationProjectId = textBoxValidation(true);
                            this.setState({ replicationIDValidated: true, selectStyle: styleStateObj, }, () => { });
                            Toast.hide();
                            Toast.success('Replication Idea ID validated successfully!', 3000, () => { });
                            return true;
                        }
                    })
                    .catch(error => {
                        this.setState({ replicationIDValidated: false }, () => { })
                        Toast.hide();
                        console.log(error)
                        Toast.fail("Could not find the Idea, please check and re-enter correct Idea ID.", 5000, () => { });
                        return false;
                    });

            }

        } else {
            this.setState({ replicationIDValidated: false }, () => { })
            Toast.fail("Idea ID must be equal to 9 characters & ID must start with 'I-'", 5000, () => { });
            return false;
        }

    }



    fetchVerticalOptions = async () => {
        try {
            Toast.loading("Fetching Verticals. Please wait...", () => { });
            const param = {
                EntityType: "Vertical",
                EntityName: this.state.accountSelectedOption ? this.state.accountSelectedOption.label : ""
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };

            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    Toast.hide();
                    let styleStateObj = this.state.selectStyle;
                    styleStateObj.verticalSelectedOption = selectStyle(true);
                    styleStateObj.subVerticalSelectedOption = selectStyle(true);
                    this.setState({
                        selectStyle: styleStateObj,
                        verticalList: data.Table1 !== undefined ? data.Table1 : [],
                        unitsAndSegmentsList: data.Table2 !== undefined ? data.Table2 : [],
                    }, () => {
                        if (this.state.verticalList) {
                            this.setState({
                                verticalSelectedOption: {
                                    label: this.state.verticalList[0].VERTICAL, value: 0
                                },
                                subVerticalSelectedOption: {
                                    label: this.state.verticalList[0].SUB_VERTICAL, value: 0
                                }
                            })

                            if (this.state.ideaItem.AccountManual === this.state.accountSelectedOption?.label) {
                                this.state.verticalList.map((item) => {
                                    if (item.VERTICAL === this.state.ideaItem.VerticalManual) {
                                        this.setState({
                                            verticalSelectedOption: {
                                                label: this.state.ideaItem.VerticalManual, value: 0
                                            },
                                            subVerticalSelectedOption: {
                                                label: this.state.ideaItem.SubVerticalName, value: 0
                                            }

                                        })
                                    }
                                })
                            }
                        }

                        let localUnit = "";
                        let localSegment = "";

                        localUnit = this.state.unitsAndSegmentsList && this.state.unitsAndSegmentsList[0].UNIT;
                        localSegment = this.state.unitsAndSegmentsList && this.state.unitsAndSegmentsList[0].SEGMENT;

                        if (this.state.ideaItem.VerticalManual === this.state.verticalSelectedOption?.label) {
                            this.state.unitsAndSegmentsList && this.state.unitsAndSegmentsList.map((item) => {
                                if (!(item.VERTICAL.toString().toLowerCase() === "ts")) {
                                    if (this.state.ideaItem.VerticalManual === item.VERTICAL) {
                                        if (item) {
                                            localUnit = item.UNIT;
                                            localSegment = item.SEGMENT;
                                        }
                                    }
                                }
                            })
                        }

                        this.setState({ Unit: localUnit, Segment: localSegment }, () => {
                            console.log("unit at fetch vertical option =>", this.state.Unit)
                            console.log("segmentat fetch vertical option  =>", this.state.Segment)
                        })
                        this.renderVerticalOptions();
                        this.renderSubVerticalOptions();
                    });
                }

            }
        } catch (error) {
            Toast.hide();
            console.log(JSON.stringify(error));
            Toast.fail('Error occured while getting Vertical details. Please try again!', 3000, () => { });
        }
    }

    fetchCountryOptions = async () => {
        try {
            const param = {
                EntityType: "COUNTRY",
                EntityName: this.state.accountSelectedOption ? this.state.accountSelectedOption.label : ""
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };

            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    let styleStateObj = this.state.selectStyle;
                    styleStateObj.countrySelectedOption = selectStyle(true);
                    this.setState({
                        selectStyle: styleStateObj,
                        countryList: data.Countries.Table1 !== undefined ? data.Countries.Table1 : [],
                    });
                }
            }
        } catch (error) {
            Toast.hide();
            Toast.fail('Error occured while getting Account specific Country details. Please try again!', 3000, () => {
                console.log(JSON.stringify(error));
            });

        }
    }

    fetchRegionOptions = async () => {
        try {
            Toast.loading("Fetching Regions. Please wait...", () => { });
            let entityType = "REGION";
            let countryName = this.state.countrySelectedOption ? this.state.countrySelectedOption.label : "";
            let accountName = this.state.accountSelectedOption ? this.state.accountSelectedOption.label : "";
            let entityName = countryName + "::" + accountName;

            const param = {
                EntityType: entityType,
                EntityName: entityName
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };
            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    Toast.hide();
                    let styleStateObj = this.state.selectStyle;
                    styleStateObj.regionSelectedOption = selectStyle(true);
                    styleStateObj.subRegionSelectedOption = selectStyle(true);
                    this.setState({
                        selectStyle: styleStateObj,
                        regionList: data.Region.Table1 !== undefined ? data.Region.Table1 : [],
                        regionSelectedOption: {
                            label: data.Region.Table1[0].Region,
                            value: data.Region.Table1[0].Region
                        },
                        subRegionList: data.Region.Table1 !== undefined ? data.Region.Table1 : [],
                        subRegionSelectedOption: {
                            label: data.Region.Table1[0].SubRegion,
                            value: data.Region.Table1[0].SubRegion
                        }
                    });
                    this.fetchRoles();
                }
            }
        } catch (error) {
            Toast.hide();
            console.log(JSON.stringify(error));
            Toast.fail('Error occured while getting Region details. Please try again!', 3000, () => { });

        }
    }

    fetchRoles = async () => {
        try {
            Toast.loading("Fetching Blackbelts. Please wait...", () => { });
            let entityType = "BB";
            let entityName = this.state.regionSelectedOption?.label;
            if (this.state.regionSelectedOption?.label === OTHER_REGIONS) {
                entityType = "BBOTHER";
                entityName = this.state.verticalSelectedOption?.label.replace(" - ", "-");
            }
            const param = {
                EntityType: entityType,
                EntityName: entityName
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param)
            };

            const response = await fetch(GET_METADATA, requestOptions)
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    Toast.hide();
                    if (data.DataverseUserRoles) {
                        this.setState({ rolesList: data.DataverseUserRoles }, () => { });

                        let filteredLDTLeadList = data.DataverseUserRoles.filter((item) => {
                            const userRole = JSON.parse(item.pg_Role).pg_role;
                            return (
                                userRole === "LDT Lead" &&
                                parseInt(this.state.OwnerOHR) !== parseInt(item.pg_ohr)
                            );
                        });
                        if (filteredLDTLeadList && filteredLDTLeadList.length > 0) {
                            if (this.state.ideaItem.LDTLeadName === null || this.state.ideaItem.LDTLeadName === undefined || this.state.ideaItem.LDTLeadName === "") {
                                this.state.ideaItem.LDTId = filteredLDTLeadList[0].pg_ohr;
                                this.state.ideaItem.LDTLeadName = filteredLDTLeadList[0].pg_username;
                                this.setState({
                                    LDTLeadSelectedOption: {
                                        label: filteredLDTLeadList[0].pg_username,
                                        value: filteredLDTLeadList[0].pg_ohr,
                                    },
                                });
                            }
                        }
                    }

                }

            }
        } catch (error) {
            Toast.hide();
            Toast.fail('Error occured while getting roles. Please try again!', 3000, () => {
                console.log(JSON.stringify(error));
            });

        }
    }



    renderCertLevelsOptions = () => {
        let options = [];
        this.state.certificationLevelsList.map((item) => {
            options.push({
                value: item.CertificationLevelId,
                label: item.CertificationLevelName
            });
            return options;
        });
        return options;
    }

    handleCertLevelChange = (e) => {
        this.setState({
            certLevelsSelectedOption: e,
            certWorkTypeSelectedOption: null,
            transSelectedOption: null,
            digitalProjectTypeSelectedOptions: null,
            aiClassificationListSelectedOption: null,
            methodologySelectedOptions: null,
            OtherTools: ""
        });
    }

    renderCertWorkTypeOptions = (selectedCert) => {
        let options = [];
        this.state.certificationWorkTypeList.map((item) => {
            if (!selectedCert || selectedCert.label === item.CertifiationLevelName) {
                options.push({
                    value: item.WorkTypeName,
                    label: item.WorkTypeName
                });
            }
            return options;
        });
        return options;
    }

    handleCertWorkTypeChange = (e) => {
        this.setState({ certWorkTypeSelectedOption: e });
    }

    renderTransLeversOptions = () => {
        let options = [];
        let result = [];
        this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
            if (this.state.ideaItem.CampaignID === item.CampaignID) {
                options.push({ value: item.TLID, label: item.TransformationLever, SOrd: item.TLOrd });
            }
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);
        result.sort((a, b) => a.SOrd - b.SOrd);
        return result
    }



    handleTransLeversChange = (e) => {
        let confirmationMessage = '';
        if (this.state.ideaItem.TransformationLeverName === "Data") {
            if (e.label !== "Data") {
                confirmationMessage = `Updating transformation lever will require fields to be filled up by idea owner or mentor with respect to the transformation selected, please make sure that fields to be filled. And also the data bridge details will be deleted. Do you wish to continue ?`;
            }
        }

        if (this.state.ideaItem.TransformationLeverName !== "Data") {
            if (e.label === "Data") {
                confirmationMessage = `Updating transformation lever to 'Data' from others will be considered as data bridge project. Please make sure that data bridge fields to be filled up by the idea owner. Do you wish to continue ?`;
            } else {
                confirmationMessage = `Updating transformation lever will require fields to be filled up by idea owner or mentor with respect to the transformation selected, please make sure that fields to be filled. And also the data bridge details will be deleted. Do you wish to continue ?`;
            }
        }

        if (window.confirm(confirmationMessage)) {
            let styleStateObj = this.state.selectStyle;
            styleStateObj.transSelectedOption = selectStyle(true);
            this.setState({
                transSelectedOption: e,
                selectStyle: styleStateObj,
                certWorkTypeSelectedOption: [],
                digitalProjectTypeSelectedOptions: null,
                aiClassificationListSelectedOption: null,
                methodologySelectedOptions: null,
                OtherTools: "",
                CodersTable: [],
            });

            if (e.label === "Digital") {
                this.renderDigitalProjectTypeOptions();
            }
        }
    }

    renderDigitalProjectTypeOptions = () => {
        let options = [];
        let result = [];
        this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
            if (item.DPType) {
                if (this.state.campaignSelectedOption?.value === item.CampaignID) {
                    if (this.state.transSelectedOption?.value === item.TLID) {
                        if (this.state.certLevelsSelectedOption?.label === "Lean") {
                            if (item.DPType !== "RPA") {
                                options.push({ value: item.DPTypeID, label: item.DPType, SOrd: item.DPOrder });
                            }
                        } else {
                            options.push({ value: item.DPTypeID, label: item.DPType, SOrd: item.DPOrder });
                        }
                    }
                }
            }
            return true;
        });
        result = options.reduce((unique, index) => {
            if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                unique.push(index);
            }
            return unique;
        }, []);

        result.sort((a, b) => a.SOrd - b.SOrd)
        return result
    };
    handleDigitalProjectTypeChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.digitalProjectTypeSelectedOptions = selectStyle(true);
        this.setState({
            CodersTable: [],
            selectStyle: styleStateObj,
            digitalProjectTypeSelectedOptions: {
                value: e.value,
                label: e.label,
            },
            methodologySelectedOptions: null,
            OtherTools: "",
            aiClassificationListSelectedOption: null
        });
    }

    renderAIClassificationList = () => {
        let options = [];
        if (this.state.transSelectedOption) {
            if (this.state.digitalProjectTypeSelectedOptions) {
                this.state.aiClassificationList && this.state.aiClassificationList.map((item) => {
                    if (item.TransformationLever === "Digital" && this.state.transSelectedOption?.label === "Digital") {
                        if (item.DigitalProjectType === this.state.digitalProjectTypeSelectedOptions.label) {
                            options.push({
                                value: item.RecID,
                                label: item.AIClassification
                            })
                        }
                    }
                })
            }
            else {
                this.state.aiClassificationList && this.state.aiClassificationList.map((item) => {
                    if (item.RecStatus === true && item.DigitalProjectType === null && item.TransformationLever === this.state.transSelectedOption.label) {
                        if (this.state.ideaItem.campaignName === "Gen AI") {
                            if (item.AIClassification === "Gen AI") {
                                options.push({
                                    value: item.RecID,
                                    label: item.AIClassification
                                })
                            }
                        } else {
                            options.push({
                                value: item.RecID,
                                label: item.AIClassification
                            })
                        }
                    }
                })
            }
        }
        // console.log("AI classification options =>",options && options.length)
        return options;
    }

    handleAIClassificationChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.aiClassificationListSelectedOption = selectStyle(true);
        this.setState({
            selectStyle: styleStateObj,
            aiClassificationListSelectedOption: {
                value: e.value,
                label: e.label,
            },
            methodologySelectedOptions: null,
            OtherTools: "",
        }, () => {
        }
        );
    }

    renderMethodologyOptions = () => {
        let options = [];
        this.state.methodologyList && this.state.methodologyList.map((item, ind) => {
            if (this.state.transSelectedOption && this.state.transSelectedOption.label === item.TransformationLever && this.state.aiClassificationListSelectedOption?.label === item.AIClassification) {
                if (this.state.digitalProjectTypeSelectedOptions) {
                    if (this.state.digitalProjectTypeSelectedOptions.label === item.DigitalProjectType) {
                        options.push({
                            value: item.RecID,
                            label: item.Methodology,
                            sortOrder: item.SOrd || 0
                        })
                    }
                }
                else {
                    options.push({
                        value: item.RecID,
                        label: item.Methodology,
                        sortOrder: item.SOrd || 0
                    })
                }
            }
        })
        options.sort((a, b) => a.sortOrder - b.sortOrder);
        // console.log("mehtodologies length =>", options.length)
        return options.map(({ value, label }) => ({ value, label }));;
    }

    setToolsMethodologies = () => {
        let localMethodology = this.state.ideaItem.MethodologyName && this.state.ideaItem.MethodologyName.replace(/[|,]/g, ",")
        localMethodology = localMethodology.split(",");
        let options = [];
        this.state.methodologyList && this.state.methodologyList.map((item, ind) => {
            if (this.state.transSelectedOption && this.state.transSelectedOption.label === item.TransformationLever && item.RecStatus === true && this.state.aiClassificationListSelectedOption?.label === item.AIClassification) {
                if (this.state.digitalProjectTypeSelectedOptions) {
                    if (this.state.digitalProjectTypeSelectedOptions.label === item.DigitalProjectType) {
                        localMethodology.map((local, index) => {
                            if (local === item.Methodology) {
                                options.push({ value: item.RecID, label: item.Methodology, sortOrder: item.SOrd || 0 })
                            }
                        })
                    }
                }
                else {
                    localMethodology.map((local, index) => {
                        if (local === item.Methodology) {
                            options.push({ value: item.RecID, label: item.Methodology, sortOrder: item.SOrd || 0 })
                        }
                    })
                }
            }
        })
        options.sort((a, b) => a.sortOrder - b.sortOrder);
        this.setState({ methodologySelectedOptions: options }, () => {
            //console.log('methodology selected option => ', this.state.methodologySelectedOptions)
        })
    }



    handleMethodologyChange = (e) => {
        if (e.length <= 10) {
            let styleStateObj = this.state.selectStyle;
            styleStateObj.methodologySelectedOptions = selectStyle(true);
            this.setState({ methodologySelectedOptions: e, selectStyle: styleStateObj, OtherTools: "" }, () => { });
        } else {
            window.alert("You can add upto 10 tools/methodologies options only.")
            return false;
        }
    }

    handleOtherToolsChange = (e) => {
        let nonWhiteSpace = e.replace(/^\s+|\s+$/gm, '');
        let styleStateObj = this.state.selectStyle;
        styleStateObj.OtherTools = textBoxValidation(true);
        if (nonWhiteSpace.length <= 300) {
            this.setState({ OtherTools: e, selectStyle: styleStateObj, }, () => { })
        } else {
            const trimmedValue = nonWhiteSpace.slice(0, 300);
            this.setState({ OtherTools: trimmedValue }, () => { });
        }
    }



    cancelEvent = () => {
        this.props.history.push("/view-all-ideas-page");
    }


    validate = () => {
        let isValid = true;
        let styleStateObj = this.state.selectStyle;

        if (this.state.accountSelectedOption.length === 0 || this.state.accountSelectedOption === "" || this.state.accountSelectedOption === null || this.state.accountSelectedOption === undefined || !this.state.accountSelectedOption) {
            isValid = false;
            styleStateObj.accountSelectedOption = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        } else {
            styleStateObj.accountSelectedOption = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }

        if (this.state.verticalSelectedOption === null || this.state.verticalSelectedOption === undefined || !this.state.verticalSelectedOption || this.state.verticalSelectedOption.length === 0) {
            isValid = false;
            styleStateObj.verticalSelectedOption = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        } else {
            styleStateObj.verticalSelectedOption = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }

        if (this.state.subVerticalSelectedOption === null || this.state.subVerticalSelectedOption === undefined || !this.state.subVerticalSelectedOption || this.state.subVerticalSelectedOption.length === 0) {
            isValid = false;
            styleStateObj.subVerticalSelectedOption = selectStyle(false);
            this.setState({
                selectStyle: styleStateObj
            })
        } else {
            styleStateObj.subVerticalSelectedOption = selectStyle(true);
            this.setState({
                selectStyle: styleStateObj
            })
        }

        if (this.state.campaignSelectedOption === "" || this.state.campaignSelectedOption === null || this.state.campaignSelectedOption === undefined || this.state.campaignSelectedOption.length === 0 || !this.state.campaignSelectedOption) {
            isValid = false;
            styleStateObj.campaignSelectedOption = selectStyle(false);
            this.setState({ selectStyle: styleStateObj })
        } else {
            styleStateObj.campaignSelectedOption = selectStyle(true);
            this.setState({ selectStyle: styleStateObj })
        }

        if (this.state.displaySubCampaign) {
            if (this.state.subCampaignOption === null || this.state.subCampaignOption === "" || this.state.subCampaignOption === undefined || !this.state.subCampaignOption) {
                isValid = false;
                styleStateObj.subCampaignOption = selectStyle(false);
                this.setState({
                    selectStyle: styleStateObj,
                });
            } else {
                styleStateObj.subCampaignOption = selectStyle(true);
                this.setState({
                    selectStyle: styleStateObj,
                });
            }
        }

        if (this.state.countrySelectedOption === "" || this.state.countrySelectedOption === null || this.state.countrySelectedOption === undefined || this.state.countrySelectedOption.length === 0 || !this.state.countrySelectedOption) {
            isValid = false;
            styleStateObj.countrySelectedOption = selectStyle(false);
            this.setState({ selectStyle: styleStateObj })
        } else {
            styleStateObj.countrySelectedOption = selectStyle(true);
            this.setState({ selectStyle: styleStateObj })
        }

        if (this.state.regionSelectedOption === "" || this.state.regionSelectedOption === null || this.state.regionSelectedOption === undefined || this.state.regionSelectedOption.length === 0 || !this.state.regionSelectedOption) {
            isValid = false;
            styleStateObj.regionSelectedOption = selectStyle(false);
            this.setState({ selectStyle: styleStateObj })
        } else {
            styleStateObj.regionSelectedOption = selectStyle(true);
            this.setState({ selectStyle: styleStateObj })
        }

        if (this.state.subRegionSelectedOption === "" || this.state.subRegionSelectedOption === null || this.state.subRegionSelectedOption === undefined || this.state.subRegionSelectedOption.length === 0 || !this.state.subRegionSelectedOption) {
            isValid = false;
            styleStateObj.subRegionSelectedOption = selectStyle(false);
            this.setState({ selectStyle: styleStateObj })
        } else {
            styleStateObj.subRegionSelectedOption = selectStyle(true);
            this.setState({ selectStyle: styleStateObj })
        }

        if (this.state.blackBeltSelectedOption === "" || this.state.blackBeltSelectedOption === null || this.state.blackBeltSelectedOption === undefined || this.state.blackBeltSelectedOption.length === 0 || !this.state.blackBeltSelectedOption) {
            isValid = false;
            styleStateObj.blackBeltSelectedOption = selectStyle(false);
            this.setState({ selectStyle: styleStateObj })
        } else {
            styleStateObj.blackBeltSelectedOption = selectStyle(true);
            this.setState({ selectStyle: styleStateObj })
        }
        if (this.state.ideaItem.MBBOHR || this.state.ideaItem.WorkflowStatus === "Approve" || this.state.ideaItem.WorkflowStatus === "Approved") {
            if (this.state.mbbSelectedOption === "" || this.state.mbbSelectedOption === null || this.state.mbbSelectedOption === undefined || this.state.mbbSelectedOption.length === 0 || !this.state.mbbSelectedOption) {
                isValid = false;
                styleStateObj.mbbSelectedOption = selectStyle(false);
                this.setState({ selectStyle: styleStateObj })
            } else {
                styleStateObj.mbbSelectedOption = selectStyle(true);
                this.setState({ selectStyle: styleStateObj })
            }
        }

        if (this.state.serviceLineSelectedOption === "" || this.state.serviceLineSelectedOption === null || this.state.serviceLineSelectedOption === undefined || this.state.serviceLineSelectedOption.length === 0 || !this.state.serviceLineSelectedOption) {
            isValid = false;
            styleStateObj.serviceLineSelectedOption = selectStyle(false);
            this.setState({ selectStyle: styleStateObj })
        } else {
            styleStateObj.serviceLineSelectedOption = selectStyle(true);
            this.setState({ selectStyle: styleStateObj })
        }

        if (this.state.subServiceLineSelectedOption === "" || this.state.subServiceLineSelectedOption === null || this.state.subServiceLineSelectedOption === undefined || this.state.subServiceLineSelectedOption.length === 0 || !this.state.subServiceLineSelectedOption) {
            isValid = false;
            styleStateObj.subServiceLineSelectedOption = selectStyle(false);
            this.setState({ selectStyle: styleStateObj })
        } else {
            styleStateObj.subServiceLineSelectedOption = selectStyle(true);
            this.setState({ selectStyle: styleStateObj })
        }


        if (this.state.LDTLeadSelectedOption === "" || this.state.LDTLeadSelectedOption === null || this.state.LDTLeadSelectedOption === undefined || this.state.LDTLeadSelectedOption.length === 0 || !this.state.LDTLeadSelectedOption) {
            isValid = false;
            styleStateObj.LDTLeadSelectedOption = selectStyle(false);
            this.setState({ selectStyle: styleStateObj })
        } else {
            styleStateObj.LDTLeadSelectedOption = selectStyle(true);
            this.setState({ selectStyle: styleStateObj })


        }

        if (this.state.Problem === "" || this.state.Problem === undefined || this.state.Problem === null || !this.state.Problem) {
            isValid = false;
            styleStateObj.Problem = textBoxValidation(false);
            this.setState({
                selectStyle: styleStateObj,
            });
        } else {
            styleStateObj.Problem = textBoxValidation(true);
            this.setState({
                selectStyle: styleStateObj,
            });
        }

        if (this.state.Solution === "" || this.state.Solution === undefined || this.state.Solution === null || !this.state.Solution) {
            isValid = false;
            styleStateObj.Solution = textBoxValidation(false);
            this.setState({
                selectStyle: styleStateObj,
            });
        } else {
            styleStateObj.Solution = textBoxValidation(true);
            this.setState({
                selectStyle: styleStateObj,
            });
        }

        if (this.state.OwnerOHR === "" || this.state.OwnerOHR === undefined || this.state.OwnerOHR === null || !this.state.OwnerOHR) {
            isValid = false;
            styleStateObj.OwnerOHR = textBoxValidation(false);
            this.setState({
                selectStyle: styleStateObj,
            });
        } else {
            styleStateObj.OwnerOHR = textBoxValidation(true);
            this.setState({
                selectStyle: styleStateObj,
            });
        }


        if (this.state.ideaItem.WorkflowStatus === "Approved" || this.state.ideaItem.WorkflowStatus === "Approve") {
            if (this.state.certLevelsSelectedOption && this.state.certLevelsSelectedOption.label === "GB") {
                isValid = false;
                Toast.fail("GB projects are not allowed to be updated by admin", 3000, () => { })
                this.setState({ selectStyle: styleStateObj })
            }


            if (this.state.transSelectedOption === null || this.state.transSelectedOption === "" || this.state.transSelectedOption === undefined || this.state.transSelectedOption.length === 0 || !this.state.transSelectedOption) {
                isValid = false;
                styleStateObj.transSelectedOption = selectStyle(false);
                this.setState({
                    selectStyle: styleStateObj,
                });
            } else {
                styleStateObj.transSelectedOption = selectStyle(true);
                this.setState({
                    selectStyle: styleStateObj,
                });
            }

            if (this.state.transSelectedOption && this.state.transSelectedOption.label === "Digital") {
                if (this.state.digitalProjectTypeSelectedOptions === null || this.state.digitalProjectTypeSelectedOptions === undefined || !this.state.digitalProjectTypeSelectedOptions || this.state.digitalProjectTypeSelectedOptions.length === 0) {
                    isValid = false;
                    styleStateObj.digitalProjectTypeSelectedOptions = selectStyle(false);
                    this.setState({
                        selectStyle: styleStateObj
                    })
                } else {
                    styleStateObj.digitalProjectTypeSelectedOptions = selectStyle(true);
                    this.setState({
                        selectStyle: styleStateObj
                    })
                }
            }

            if (this.state.aiClassificationListSelectedOption === null || this.state.aiClassificationListSelectedOption === undefined || this.state.aiClassificationListSelectedOption.length === 0 || !this.state.aiClassificationListSelectedOption) {
                isValid = false;
                styleStateObj.aiClassificationListSelectedOption = selectStyle(false)
                this.setState({
                    selectStyle: styleStateObj
                })
            }
            else {
                styleStateObj.aiClassificationListSelectedOption = selectStyle(true)
                this.setState({
                    selectStyle: styleStateObj
                })
            }
            if (this.state.methodologySelectedOptions === null || this.state.methodologySelectedOptions === undefined || !this.state.methodologySelectedOptions || this.state.methodologySelectedOptions.length === 0) {
                isValid = false;
                styleStateObj.methodologySelectedOptions = selectStyle(false);
                this.setState({
                    selectStyle: styleStateObj,
                });
            }
            else {
                styleStateObj.methodologySelectedOptions = selectStyle(true);
                this.setState({
                    selectStyle: styleStateObj,
                });
            }

        }

        // VD validation starts here....
        if (this.state.certLevelsSelectedOption?.label === "Lean") {
            // if (this.state.ideaItem.ProjectPPTFilename === "" || this.state.ideaItem.ProjectPPTFilename === undefined || this.state.ideaItem.ProjectPPTFilename === null || !this.state.ideaItem.ProjectPPTFilename) {
            //     if (this.state.filename1 === "" || this.state.filename1 === undefined || this.state.filename1 === null) {
            //         isValid = false
            //         Toast.fail("Please upload the project presentation deck file.", 3000, () => { });
            //     }
            // }

            if (this.state.impactOptionSelected === null || this.state.impactOptionSelected === undefined || this.state.impactOptionSelected === "" || this.state.impactOptionSelected.length === 0 || !this.state.impactOptionSelected) {
                isValid = false;
                Toast.fail("Please select Value Delivery Type.", 3000, () => { });
            }

            if (this.state.impactOptionSelected && this.state.impactOptionSelected.label !== NO_VD) {
                if (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT) {
                    if (this.state.businessImpactValueArray.length > 0) {
                        let impactGenpactTrue = this.state.businessImpactValueArray.some(vendor => vendor['ImpactType'] === IMPACT_TO_GENPACT)
                        let impactClientTrue = this.state.businessImpactValueArray.some(vendor => vendor['ImpactType'] === IMPACT_TO_CLIENT)
                        if (impactGenpactTrue === false) {
                            isValid = false;
                            Toast.fail('Please add both impact types.', 3000, () => { })
                        }
                        if (impactClientTrue === false) {
                            isValid = false;
                            Toast.fail('Please add both impact types.', 3000, () => { })
                        }
                    }
                }
                if (!this.state.monetizableProjectSelectedOption || this.state.monetizableProjectSelectedOption === null || this.state.monetizableProjectSelectedOption.length === 0 || this.state.monetizableProjectSelectedOption === undefined) {
                    isValid = false;
                    Toast.fail("Please select monetizatable project.", 5000, () => { });
                }

                if (this.state.monetizableProjectSelectedOption && this.state.monetizableProjectSelectedOption.label === "Yes") {
                    if (this.state.monetizationStatusSelectedOption.length === 0 || this.state.monetizationStatusSelectedOption === undefined || this.state.monetizationStatusSelectedOption === "" || this.state.monetizationStatusSelectedOption === null || !this.state.monetizationStatusSelectedOption) {
                        isValid = false;
                        Toast.fail("Since this project has been marked as Monetizable, monetizable status has to be selected.", 5000, () => { })
                    }

                    if (this.state.monetizationStatusSelectedOption?.label === "Approved by Client") {
                        if (this.state.SowID === undefined || this.state.SowID === "" || this.state.SowID.length === 0 || this.state.SowID === null || !this.state.SowID) {
                            isValid = false;
                            Toast.fail("Please fill SOW ID/SFDC/OLI ID", 3000, () => { })
                        }
                    }

                    if ((this.state.businessImpactValueArray && this.state.businessImpactValueArray.filter(item => item.IsMonetized === "Yes")).length > 0) { }
                    else {
                        isValid = false;
                        Toast.fail("Since, this is a monetizable project, there needs to be at least one ‘Monetizable’ check box ticked in the Value Delivery category", 5000, () => { })
                    }
                }


                if ((this.state.businessImpactValueArray.length === 0 || this.state.businessImpactValueArray === null || !this.state.businessImpactValueArray || this.state.businessImpactValueArray === undefined || this.state.businessImpactValueArray === "")) {
                    Toast.fail("Value Delivery cannot be empty, please fill and resubmit.", 3000, () => { });
                    isValid = false;
                }
                if (this.state.businessImpactValueArray && this.state.businessImpactValueArray !== null) {
                    if (parseInt(this.state.FinalImpactDollar) <= 0) {
                        Toast.fail("Total $ Impact cannot be zero. Please check and resubmit.", 3000, () => { });
                        isValid = false;
                    }
                    if (this.state.FinalImpactFTE > 0 && this.state.FinalImpactDollar <= 0) {
                        Toast.fail("Total $ Impact cannot be zero when FTE is non-zero. Please check and resubmit.", 3000, () => { });
                        isValid = false;
                    }
                    let showDollarZeroError = false;
                    let showFTEZeroError = false;
                    let showFTEGreaterError = false;
                    this.state.businessImpactValueArray.filter((item) => {
                        if (parseFloat(item.DollarImpact) === 0 || parseFloat(item.DollarImpact) === "" || !item.DollarImpact || item.DollarImpact === null) {
                            isValid = false;
                            showDollarZeroError = true;
                        }
                        if (item && item.isFTEPresent === true) {
                            if (parseFloat(item.FTEImpact)) { }
                            else {
                                isValid = false;
                                showFTEZeroError = true;
                            }
                            if (parseFloat(item.FTEImpact) === 0) {
                                isValid = false;
                                showFTEZeroError = true;
                            }
                            if (parseFloat(item.FTEImpact) > parseFloat(item.DollarImpact)) {
                                isValid = false;
                                showFTEGreaterError = true;
                            }
                        }
                    });

                    if (showDollarZeroError) {
                        Toast.fail("$ Impact value cannot be zero.", 3000, () => { })
                    }
                    if (showFTEZeroError) {
                        Toast.fail("FTE Impact value cannot be zero.", 3000, () => { })
                    }
                    if (showFTEGreaterError) {
                        Toast.fail("FTE impact value cannot be greater than $ Impact value.", 3000, () => { })
                    }
                }

                // if (this.state.showClientFields) {
                //     if (!this.state.clientName || this.state.clientName === null || this.state.clientName === undefined || this.state.clientName === "") {
                //         isValid = false
                //         Toast.fail("Please fill client name.", 3000, () => { });
                //     }
                //     if (!this.state.clientRole || this.state.clientRole === null || this.state.clientRole === undefined || this.state.clientRole === "") {
                //         isValid = false
                //         Toast.fail("Please fill client role.", 3000, () => { });
                //     }
                //     if (!this.state.clientSignOffDate || this.state.clientSignOffDate === null || this.state.clientSignOffDate === undefined || this.state.clientSignOffDate === "") {
                //         isValid = false
                //         Toast.fail("Please fill client sign-off date.", 3000, () => { });
                //     }
                //     if (this.state.signOffFilename === null || this.state.signOffFilename === "" || this.state.signOffFilename === undefined || this.state.signOffFilename.length === 0 || !this.state.signOffFilename) {
                //         isValid = false
                //         Toast.fail("Please upload the client approval document.", 3000, () => { });
                //     }
                // }

                // if (this.state.showGOLFields) {
                //     if (this.state.golOhr === "" || this.state.golOhr === null || this.state.golOhr === undefined) {
                //         isValid = false;
                //         Toast.fail("Please fill GOL OHR.", 3000, () => { })
                //     }

                //     if (this.state.golOhr) {
                //         if (this.state.golFullname === "" || this.state.golFullname === null || this.state.golFullname === undefined || this.state.golFullname.length === 0 || !this.state.golFullname) {
                //             isValid = false;
                //             Toast.fail("Please fill GOL OHR to fetch GOL name.")
                //         }
                //     }

                //     if (this.state.golFpnaFileDetails !== null || !this.state.golFpnaFileDetails) {
                //         if (this.state.golFpnaFileDetails[0].label === "" && this.state.golFpnaFileDetails[1].label === "") {
                //             isValid = false;
                //             Toast.fail("Please upload the GOL / FP&A approval document.", 3000, () => { })
                //         }
                //     }
                //     if (this.state.isFpnaRequired) {
                //         if (!this.state.fpnaOhr || this.state.fpnaOhr === null || this.state.fpnaOhr === undefined || this.state.fpnaOhr === "") {
                //             isValid = false;
                //             Toast.fail("Please fill FP&A OHR.", 3000, () => { })
                //         }
                //         if (this.state.fpnaOhr) {
                //             if (!this.state.fpnaName || this.state.fpnaName === null || this.state.fpnaName === undefined || this.state.fpnaName === "") {
                //                 isValid = false;
                //                 Toast.fail("Please fill FP&A OHR to fetch FP&A Name.", 3000, () => { })
                //             }
                //         }
                //     }
                // }


            }
        }


        // if (this.displayCoderSection()) {
        //     if (this.state.CodersTable.length === 0 || !this.state.CodersTable || this.state.CodersTable === null || this.state.CodersTable === undefined) {
        //         Toast.fail("Atleast 1 coder OHR is required.", 3000)
        //         isValid = false;
        //     }
        // }

        // if (this.state.NewOrReplicatedIdea) {
        //     if (this.state.ReplicationProjectId === null || this.state.ReplicationProjectId === undefined || this.state.ReplicationProjectId === "") {
        //         Toast.fail("Please enter the Idea ID to validate the replication.", 3000)
        //         isValid = false;
        //         styleStateObj.ReplicationProjectId = textBoxValidation(false);
        //         this.setState({
        //             selectStyle: styleStateObj,
        //         });
        //     } else {
        //         if(this.state.ReplicationProjectId && this.state.ReplicationProjectId.length === 9){
        //             if(this.state.ReplicationProjectId.startsWith("I-")){
        //                 if (this.state.replicationIDValidated) {
        //                     styleStateObj.ReplicationProjectId = textBoxValidation(true);
        //                     this.setState({
        //                         selectStyle: styleStateObj,
        //                     });
        //                 } else {
        //                     isValid = false;
        //                     Toast.fail("Please get the Idea ID verified.", 5000, () => { });
        //                     styleStateObj.ReplicationProjectId = textBoxValidation(false);
        //                     this.setState({
        //                         selectStyle: styleStateObj,
        //                     });
        //                 }
        //             }else{
        //                 isValid = false;
        //                 Toast.fail("Idea ID must start with 'I-'", 5000, () => { });
        //                 styleStateObj.ReplicationProjectId = textBoxValidation(false);
        //                 this.setState({
        //                     selectStyle: styleStateObj,
        //                 });
        //             }
        //         }else{
        //             isValid = false;
        //             Toast.fail("Please re-enter proper Idea ID for replication.", 5000, () => { });
        //             styleStateObj.ReplicationProjectId = textBoxValidation(false);
        //             this.setState({
        //                     selectStyle: styleStateObj,
        //                 });
        //         }
        //     }
        // }

        // VD validation ends here....

        return isValid;
    }
    newBusinessImpactSummary() {
        let myArray = [...this.state.businessImpactValueArray];
        const groupedData = myArray.reduce((accumulator, currentValue) => {
            const impactType = currentValue.impactType;
            const monetizableType = currentValue.monetizableType;
            const fteValue = parseFloat(currentValue.fteValue) || 0.0;
            const dollarValue = parseFloat(currentValue.dollarValue) || 0.0;

            const existingRow = accumulator.find(row => row.impactType === impactType && row.monetizableType === monetizableType);
            if (existingRow) {
                existingRow.fteValue += fteValue
                existingRow.dollarValue += dollarValue
            } else {
                accumulator.push({ impactType, monetizableType, fteValue, dollarValue });
            }
            return accumulator;
        }, []);
        this.setState({ summaryArray: groupedData }, () => { });
        this.setState({ businessImpactValueArray: this.state.businessImpactValueArray }, () => { })

        let isFpnaRequired = false;
        this.state.businessImpactValueArray && this.state.businessImpactValueArray.map((item) => {
            if (item.ImpactType === IMPACT_TO_GENPACT) {
                if (item.MonetizableType === "Increase in Revenue" || item.MonetizableType === "Reduction in Cost" || item.MonetizableType === "Productivity") {
                    isFpnaRequired = true;
                }
            }
            if (item.MonetizableType && item.MonetizableType === "Productivity") {
                isFpnaRequired = true;
            }
        })
        this.setState({ isFpnaRequired: isFpnaRequired }, () => { })

        if (this.state.impactOptionSelected && (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT || this.state.impactOptionSelected.label === VD_TO_CLIENT)) {
            let clientNonProductivity = this.state.businessImpactValueArray && this.state.businessImpactValueArray.some((e) => e.ImpactType === IMPACT_TO_CLIENT && ["Increase in Revenue", "Reduction in Cost", "Cash Impact", "Others"].includes(e.MonetizableType));
            if (clientNonProductivity) {
                this.setState({ showClientFields: true }, () => { })
            } else {
                this.setState({ showClientFields: false }, () => { })
                let genpactNonProducitivity = this.state.businessImpactValueArray.some((e) => e.ImpactType === IMPACT_TO_GENPACT && ["Increase in Revenue", "Reduction in Cost", "Cash Impact", "Others"].includes(e.MonetizableType));
                if (genpactNonProducitivity) {

                } else {
                    this.setState({ showClientFields: false }, () => { })
                }
            }
        }
    }


    mainUpdateFunction = async () => {
        if (this.validate()) {
            if (window.confirm("Are you sure you want to proceed to update ?")) {
                Toast.loading("Update in progress...", () => { });
                try {
                    await Promise.all([this.UpdateIdea(), this.state.ideaItem.CertificationLevelName === "Lean" ? this.updateIdeaDocuments() : null]);
                    Toast.hide();
                    Toast.info("Updated successfully!", 5000, () => {
                        window.location = "/view-all-ideas-page";
                    });
                } catch (error) {
                    Toast.fail(`${error}`, 3000);
                    Toast.hide();
                }
            }
        }
        else {
            Toast.fail('Required fields are missing or have invalid values. Please correct and try again.', 3000);
        }
    };



    triggerDocumentUploadFunction = () => {
        let localResult = false;

        // proposal shared file
        if (this.state.ideaItem.ProjectPPTFileName) {
            if (this.state.filename1 !== this.state.ideaItem.ProjectPPTFileName) {
                localResult = true;
            }
        } else {
            if (this.state.filename1) {
                localResult = true;
            }
        }


        if (this.state.ideaItem.CustomerSignoffFileName) {
            if (this.state.signOffFilename !== this.state.ideaItem.CustomerSignoffFileName) {
                localResult = true;
            }
        } else {
            if (this.state.signOffFilename) {
                localResult = true;
            }
        }


        if (this.state.ideaItem.GOLFileName) {
            if (this.state.filename3 !== this.state.ideaItem.GOLFileName) {
                localResult = true;
            }
        } else {
            if (this.state.filename3) {
                localResult = true;
            }
        }


        if (this.state.ideaItem.FPnAFileName) {
            if (this.state.filename4 !== this.state.ideaItem.FPnAFileName) {
                localResult = true;
            }
        } else {
            if (this.state.filename4) {
                localResult = true;
            }
        }
        return localResult;
    }




    updateIdeaDocuments = () => {
        return new Promise((resolve, reject) => {
            if (this.triggerDocumentUploadFunction()) {
                if (this.validate()) {
                    let param = {
                        SaveType: "documentData",
                        IdeaId: this.props.location.state,
                        IdeaName: this.state.ideaItem.IdeaName,
                        ModifiedByOHR: this.sessionData.profile.oHRId,
                        Role: "Admin",

                        ProjectPPTDeck: this.state.base64File1,
                        ProjectPPTFilename: this.state.filename1 ? this.state.filename1 : this.state.ideaItem.ProjectPPTFileName,
                        ProjectPPTType: this.state.fileType1 ? this.state.fileType1 : this.state.ideaItem.ProjectPPTType,

                        CustomerLeadSignOff: this.state.signOffContent,
                        CustomerSignoffFilename: this.state.signOffFilename ? this.state.signOffFilename : this.state.ideaItem.CustomerSignoffFileName,
                        CustomerSignoffType: this.state.signOffFileType ? this.state.signOffFileType : this.state.ideaItem.CustomerSignoffType,

                        golApproval: this.state.base64File3,
                        golApprovalFileName: this.state.filename3,
                        golApprovalType: this.state.fileType3,

                        fpnaApproval: this.state.base64File4,
                        fpnaApprovalFileName: this.state.filename4,
                        fpnaApprovalType: this.state.fileType4,

                        FPnAFileNameMonetization: this.state.FPnAFileNameMonetization,
                        FPnAFileTypeMonetization: this.state.FPnAFileTypeMonetization,
                        FPnAFileMonetization: this.state.FPnAFileMonetization,

                    }
                    console.log("file upload param =>", param)
                    const requestOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            "Authorization": "Bearer " + this.accessToken,
                        },
                        body: JSON.stringify(param)
                    };
                    fetch(`${IDEA_ADMIN_UPDATE}`, requestOptions)
                        .then(response => response.json())
                        .then(data => {
                            if (data.message === "Idea documents Updated succesfully.") {
                                resolve();
                            } else {
                                reject("Documents upload failed.");
                            }
                        })
                        .catch = (err) => {
                            reject(err);
                            console.log("error =>", err)
                        }
                } else {
                    Toast.fail('Some of the required fields for Idea are not set. Please set and resubmit.', 3000, () => { });
                    return;
                }

            } else {
                resolve()
            }


        })
    }


    UpdateIdea = async () => {
        return new Promise((resolve, reject) => {
            if (this.validate()) {
                let filteredBIData = this.state.businessImpactValueArray.filter(function (e) {
                    return (
                        e !== null && e !== undefined && parseFloat(e.DollarImpact) > 0 &&
                        ((e.isFTEPresent && parseFloat(e.FTEImpact) > 0) || (!e.isFTEPresent))
                    );
                });

                let LDTLogsPostData = [];
                this.state.LDTLogs && this.state.LDTLogs.map((item, index) => {
                    if (item.IsQBR) {
                        let localData = [...this.state.LDTLogs];
                        localData[index].IsQBR = localData[index].IsQBR.label;
                        LDTLogsPostData = localData;
                    }
                });

                let CodersTableWithSOrd = this.state.CodersTable && this.state.CodersTable.map((item, index) => ({ ...item, SOrd: index }));

                let MethodolodyToolsSelectedLabels = '';
                if (this.state.methodologySelectedOptions) {
                    MethodolodyToolsSelectedLabels = this.state.methodologySelectedOptions.map(option => `${option.label}`).join('|');
                }

                let param = {
                    SaveType: "projectData",

                    IdeaName: this.state.ideaItem.IdeaName,
                    IdeaIDAlpha: this.state.ideaItem.IdeaIDAlpha,
                    IdeaId: this.state.ideaItem.IdeaId,
                    LeanID: this.state.ideaItem.LeanID,

                    Role: "Admin",
                    UpdaterOHR: this.sessionData.profile.oHRId,
                    UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                    UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
                    updaterAction: "Update",

                    IdeaId: this.props.location.state,
                    OwnerEmail: `${this.state.OwnerOHR}@genpact.com`,
                    OwnerName: this.state.OwnerName,
                    OwnerOHR: this.state.OwnerOHR,

                    CreatorEmail: this.state.ideaItem.CreatorEmail,
                    CreatorName: this.state.ideaItem.CreatorName,
                    CreatorOHR: this.state.ideaItem.CreatorOHR,

                    AccountManual: this.state.accountSelectedOption ? this.state.accountSelectedOption.label : this.state.ideaItem.AccountManual,
                    HoldingAccount: this.state.HoldingAccount,
                    VerticalManual: this.state.verticalSelectedOption ? this.state.verticalSelectedOption.label : this.state.ideaItem.VerticalManual,
                    SubVerticalManual: this.state.subVerticalSelectedOption ? this.state.subVerticalSelectedOption.label : this.state.ideaItem.SubVerticalManual,
                    Country: this.state.countrySelectedOption ? this.state.countrySelectedOption.label : this.state.ideaItem.Country,
                    RegionManual: this.state.regionSelectedOption ? this.state.regionSelectedOption.label : this.state.ideaItem.regionManual,
                    SubRegion: this.state.subRegionSelectedOption ? this.state.subRegionSelectedOption.label : this.state.ideaItem.SubRegion,

                    CampaignName: this.state.campaignSelectedOption ? this.state.campaignSelectedOption.label : this.state.ideaItem.CampaignName,
                    CampaignID: this.state.campaignSelectedOption ? this.state.campaignSelectedOption.value : this.state.ideaItem.CampaignID,
                    DataBridgeTheme: this.state.dataBridgeProjectSelectedOption ? this.state.dataBridgeProjectSelectedOption.label : this.state.ideaItem.DataBridgeTheme,
                    SubCampaignName: this.state.subCampaignOption?.label,
                    SubCampaignID: this.state.subCampaignOption?.value,

                    ServiceLineName: this.state.serviceLineSelectedOption ? this.state.serviceLineSelectedOption.label : this.state.ideaItem.ServiceLineName,
                    SubServiceLine: this.state.subServiceLineSelectedOption ? this.state.subServiceLineSelectedOption.label : this.state.ideaItem.SubServiceLine,

                    Problem: this.state.Problem ? this.state.Problem : this.state.ideaItem.Problem,
                    Solution: this.state.Solution ? this.state.Solution : this.state.ideaItem.Solution,

                    BlackBeltUserId: this.state.blackBeltSelectedOption ? this.state.blackBeltSelectedOption.value : "",
                    BlackBeltUserName: this.state.blackBeltSelectedOption ? this.state.blackBeltSelectedOption.label : "",
                    MBBOHR: this.state.mbbSelectedOption ? this.state.mbbSelectedOption.value : this.state.ideaItem.MBBOHR,
                    MBBName: this.state.mbbSelectedOption ? this.state.mbbSelectedOption.label : this.state.ideaItem.MBBName,
                    LDTId: this.state.LDTLeadSelectedOption ? this.state.LDTLeadSelectedOption.value : this.state.ideaItem.LDTId,
                    LDTName: this.state.LDTLeadSelectedOption ? this.state.LDTLeadSelectedOption.label : this.state.ideaItem.LDTLeadName,

                    NewOrReplicatedIdea: this.state.NewOrReplicatedIdea,
                    ReplicationProjectId: this.state.NewOrReplicatedIdea ? this.state.ReplicationProjectId : "",

                    // IsReplicationVerified: false,

                    CertificationLevelName: this.state.certLevelsSelectedOption ? this.state.certLevelsSelectedOption.label : "",
                    CertificationWorkTypeName: this.state.certWorkTypeSelectedOption ? this.state.certWorkTypeSelectedOption.label : "",
                    TransformationLeverName: this.state.transSelectedOption ? this.state.transSelectedOption.label : this.state.ideaItem.TransformationLeverName,
                    TLID: this.state.transSelectedOption ? this.state.transSelectedOption.value : "",
                    DigitalProjectType: this.state.digitalProjectTypeSelectedOptions ? this.state.digitalProjectTypeSelectedOptions.label : "",
                    DPTypeID: this.state.digitalProjectTypeSelectedOptions ? this.state.digitalProjectTypeSelectedOptions.value : "",
                    AIClassification: this.state.aiClassificationListSelectedOption?.label,
                    MethodologyName: MethodolodyToolsSelectedLabels,
                    OtherTools: this.state.OtherTools ? this.state.OtherTools : "",
                    codersTableUpdated: this.checkifCoderTableUpdated(this.state.olderCoderTable, this.state.CodersTable),
                    CodersField: CodersTableWithSOrd ? CodersTableWithSOrd : [],


                    IsZeroImpactProject: this.state.ideaItem.IsZeroImpactProject,
                    IsSharedToSixSigma: this.state.IsSharedToSixSigma,
                    IsBestInClass: this.state.IsBestInClass,
                    ReplicabilityIndex: this.state.replicaIndex ? this.state.replicaIndex.value : "",

                    Unit: this.state.Unit,
                    Segment: this.state.Segment,

                    BusinessImpactData: filteredBIData,
                    FinalImpactDollar: this.state.FinalImpactDollar,
                    FinalImpactFTE: this.state.FinalImpactFTE,


                    VDType: this.state.impactOptionSelected ? this.state.impactOptionSelected.label : this.state.ideaItem.VDType,
                    IsVDMonetizable: this.state.monetizableProjectSelectedOption ? this.state.monetizableProjectSelectedOption.label : "",
                    MonetizationStatus: this.state.monetizationStatusSelectedOption ? this.state.monetizationStatusSelectedOption.label : "",
                    IsMbbMonetizable: this.state.ideaItem.IsMbbMonetizable ? this.state.ideaItem.IsMbbMonetizable : "",
                    SowID: this.state.Sow ? this.state.Sow : this.state.SowID,

                    ClientName: this.state.clientName,
                    ClientRole: this.state.clientRole,
                    ClientSignOffDate: this.state.clientSignOffDate,

                    GolOhr: this.state.golFullname ? this.state.golOhr : "",
                    GolFullname: this.state.golFullname,
                    FpnaOhr: this.state.fpnaName ? this.state.fpnaOhr : "",
                    FpnaName: this.state.fpnaName,

                    GOLNameMonetization: this.state.golMonetizationName ? this.state.golMonetizationName : this.state.ideaItem.GOLNameMonetization,
                    GOLOHRMonetization: this.state.golMonetizationOhr ? this.state.golMonetizationOhr : this.state.ideaItem.GOLOHRMonetization,
                    FPnAOHRMonetization: this.state.FPnAOHRMonetization ? this.state.FPnAOHRMonetization : "",
                    FPnANameMonetization: this.state.FPnANameMonetization ? this.state.FPnANameMonetization : this.state.FPnANameMonetization,

                    ImpactTyepChanged: this.state.qcImpactTagChangeSelected ? this.state.qcImpactTagChangeSelected.label : "",
                    DeliveryCategorizedSelect: this.state.qcDeliveryCategorizedSelect ? this.state.qcDeliveryCategorizedSelect.label : "",
                    DeliveryComputedCorrectlySelected: this.state.deliveryComputedCorrectlySelected ? this.state.deliveryComputedCorrectlySelected.label : "",
                    SignOffDeliverySelected: this.state.signOffDeliverySelected ? this.state.signOffDeliverySelected.label : null,

                    //AI First
                    IsIdeaReplicable: this.state.IsIdeaReplicableSelectedOption ? this.state.IsIdeaReplicableSelectedOption.label === "Yes" ? 1 : 0 : "",
                    SolnComplexity: this.state.solutionComplexitySelectedOption ? this.state.solutionComplexitySelectedOption.label : "",
                    IsSolnFeasible: this.state.solutionFeasibleSelectedOption ? this.state.solutionFeasibleSelectedOption.label === "Yes" ? 1 : 0 : "",
                    IsAI: this.state.isAISelectedOption ? this.state.isAISelectedOption.label : "",
                    LinkBRD: this.state.AIBRD ? this.state.AIBRD : "",
                    AIReason: this.state.AIReason ? this.state.AIReason : "",
                    LDTLogs: LDTLogsPostData,
                }
                console.log("Param =>", param);
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": "Bearer " + this.accessToken,
                    },
                    body: JSON.stringify(param)
                };
                fetch(`${IDEA_ADMIN_UPDATE}`, requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        console.log("data =>", data)
                        Toast.hide();
                        if (data.message === "Idea has been Updated") {
                            resolve();
                        } else {
                            reject("Data update failed.");
                        }
                    })
                    .catch = (err) => {
                        reject(err);
                        console.log('error =>', JSON.stringify(err))
                        Toast.fail("There is a failure in updating the project. Please try again.", 3000, () => { })
                    }

            }
            else {
                Toast.fail('Some of the required fields for Idea are not set. Please set and resubmit.', 3000, () => { });
                return;
            }

        })


    }

    addMonetizableValues = (e) => {
        let MonetizedBiArray = [];
        let fteValue = 0;
        let dollarValue = 0;
        this.state.businessImpactValueArray.filter((item) => {
            if (item.IsMonetized === "Yes") {
                MonetizedBiArray.push(item)
            }
        })
        if (MonetizedBiArray) {
            const groupedData = MonetizedBiArray.reduce((accumulator, currentValue) => {
                const ImpactType = currentValue.ImpactType;
                const fteValue = parseFloat(currentValue.fteValue) || 0.0;
                const dollarValue = parseFloat(currentValue.dollarValue) || 0.0;
                const existingRow = accumulator.find(row => row.ImpactType === ImpactType);
                if (existingRow) {
                    existingRow.fteValue += fteValue
                    existingRow.dollarValue += dollarValue
                }
                else {
                    accumulator.push({ ImpactType, fteValue, dollarValue });
                }
                return accumulator;
            }, []);
            if (groupedData.length === 0) {
                fteValue = 0
                dollarValue = 0
            } else {
                fteValue = groupedData[0].fteValue
                dollarValue = groupedData[0].dollarValue
            }
            this.setState({
                totalMonetizedFTE: fteValue,
                totalMonetizedDollar: dollarValue
            }, () => { })
        }
    }


    handleQCImpactTagChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.qcImpactTagChangeSelected = selectStyle(true);
        this.setState({ qcImpactTagChangeSelected: e, selectStyle: styleStateObj, }, () => { })
    }
    handleDeliveryCategorizedChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.qcDeliveryCategorizedSelect = selectStyle(true);
        this.setState({ qcDeliveryCategorizedSelect: e, selectStyle: styleStateObj, }, () => { })

    }
    handledeliveryComputedCorrectlySelectedChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.deliveryComputedCorrectlySelected = selectStyle(true);
        this.setState({ deliveryComputedCorrectlySelected: e, selectStyle: styleStateObj, }, () => { })
    }
    handleSignOffDeliveryChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.signOffDeliverySelected = selectStyle(true);
        this.setState({ signOffDeliverySelected: e, selectStyle: styleStateObj, }, () => { })
    }

    // value delivery function starts
    pull_data = (businessImpactValueArray) => {
        this.setState({ businessImpactValueArray: businessImpactValueArray }, () => {
            this.newBusinessImpactSummary()
        })
        let dollarTotal = 0.0;
        let fteValue = 0.0;
        businessImpactValueArray && businessImpactValueArray.map((item) => {
            if (item && item.DollarImpact) {
                dollarTotal += parseFloat(item.DollarImpact);
            }
            if (item && item.dollarValue) {
                dollarTotal += parseFloat(item.dollarValue);
            }
            if (item && item.FTEImpact) {
                fteValue += parseFloat(item.FTEImpact)
            }
            if (item && item.fteValue) {
                fteValue += parseFloat(item.fteValue)
            }
        })
        this.setState({ FinalImpactDollar: dollarTotal }, () => { })
        this.setState({ FinalImpactFTE: fteValue }, () => { })
    }
    remove_bi_data_after_delete = (filteredIdeaArray) => {
        if (filteredIdeaArray) {
            this.setState({ businessImpactValueArray: filteredIdeaArray }, () => {
                this.newBusinessImpactSummary()
                let dollarTotal = 0.0;
                let fteValue = 0.0;
                this.state.businessImpactValueArray.map((item) => {
                    if (item && item.DollarImpact) {
                        dollarTotal += parseFloat(item.DollarImpact);
                    }
                    if (item && item.dollarValue) {
                        dollarTotal += parseFloat(item.dollarValue);
                    }
                    if (item && item.FTEImpact) {
                        fteValue += parseFloat(item.FTEImpact)
                    }
                    if (item && item.fteValue) {
                        fteValue += parseFloat(item.fteValue)
                    }
                })
                this.setState({ FinalImpactDollar: dollarTotal }, () => { })
                this.setState({ FinalImpactFTE: fteValue }, () => { })

            })
        }

    }

    pull_file_data = ({ fileName, fileType, fileContent, showClientApprovalFields
        , SowID, FPnAOHRMonetization, FPnANameMonetization }) => {
        if (fileName) {
            this.setState({ FPnAFileNameMonetization: fileName }, () => { })
        }
        if (fileType) {
            this.setState({ FPnAFileTypeMonetization: fileType }, () => { })
        }
        if (fileContent) {
            this.setState({ FPnAFileMonetization: fileContent }, () => { })
        }

        this.setState({
            showClientApprovalFields: showClientApprovalFields,
            SowID: SowID,
            FPnAOHRMonetization: FPnAOHRMonetization,
            FPnANameMonetization: FPnANameMonetization
        }, () => { })

    }
    pull_monetizedTotal = ({ fteValue, dollarValue }) => {
        if (fteValue) {
            this.setState({ totalMonetizedDollar: fteValue }, () => { })
        }
        if (dollarValue) {
            this.setState({ totalMonetizedFTE: dollarValue }, () => { })
        }
    }
    pull_monetizableProject = (e) => {
        this.setState({ monetizableProjectSelectedOption: e }, () => { })
    }
    pull_monetizableStatus = (e) => {
        console.log("received value =>", e)
        this.setState({ monetizationStatusSelectedOption: e }, () => {
            console.log('status set', this.state.monetizationStatusSelectedOption)
        })
    }
    pull_monetization_fpna_name = (localFpnaName) => {
        this.setState({ FPnANameMonetization: localFpnaName }, () => {

        })
    }
    pull_monetization_fpna_ohr = (localFpnaohr) => {
        this.setState({ FPnAOHRMonetization: localFpnaohr }, () => { })
    }
    handleVDTypeChange = (e) => {
        this.setState({ impactOptionSelected: e, impactChanged: true }, () => {
            if (this.state.impactOptionSelected.label === NO_VD) {
                this.setState({
                    signOffFilename: "",
                    signOffFileType: "",
                    signOffContent: "",
                    filename3: "",
                    fileType3: "",
                    base64File3: "",
                    filename4: "",
                    fileType4: "",
                    base64File4: "",
                    clientName: "",
                    clientRole: "",
                    clientSignOffDate: "",
                    fpnaName: "",
                    golFullname: "",
                    fpnaOhr: "",
                    golOhr: "",
                    showClientFields: false,
                    showGOLFields: false,
                    monetizableProjectSelectedOption: null,
                    businessImpactValueArray: [],
                    IsVDMonetizable: "",

                })
            }
            if (this.state.impactOptionSelected.label === VD_TO_CLIENT) {
                this.setState({ showClientFields: true, showGOLFields: true })
            }
            if (this.state.impactOptionSelected.label === VD_TO_GENPACT) {
                this.setState({ showClientFields: false, showGOLFields: true })
            }
            if (this.state.impactOptionSelected.label === VD_TO_CLIENT_PLUS_GENPACT) {
                this.setState({ showClientFields: true, showGOLFields: true })
            }
        })
    }

    fetchFPAOHRforIncreaseInRevenue = (e) => { }
    pull_monetization_sowId = (localSowId) => {
        this.setState({ SowID: localSowId }, () => { })
    }

    pullMonetizationGOLName = (localGOLName) => {
        this.setState({ golMonetizationName: localGOLName }, () => { })
    }
    pullMonetizationGOLOhr = (localGOLOhr) => {
        this.setState({ golMonetizationOhr: localGOLOhr }, () => { })
    }
    pullCategoryNotListed = (localShowHref) => {
        this.setState({ showHrefModal: localShowHref }, () => {

        });
    };
    // value delivery function ends



    // function for FPNAGOL component starts here

    // ppt deck file details
    pull_fileDetails = (obj) => {
        this.setState({ golFpnaFileDetails: obj }, () => { })
    }

    pullPPTDeck = (fileName, fileType, fileContent) => {
        this.setState({ filename1: fileName, fileType1: fileType, base64File1: fileContent }, () => {
            //console.log("filename1 =>",this.state.filename1)
            // console.log("typeof filename1 =>",typeof this.state.filename1)
        })
    }
    pullClientDocName = (fileName) => {
        this.setState({ signOffFilename: fileName, }, () => { })
    }
    pullClientDocType = (fileType) => {
        this.setState({ signOffFileType: fileType }, () => { })
    }
    pullClientDocContent = (fileContent) => {
        this.setState({ signOffContent: fileContent }, () => { })
    }

    // gol file details
    pullgolFileName = (fileName3) => {
        this.setState({ filename3: fileName3 }, () => { })
    }
    pullgolFileType = (fileType3) => {
        this.setState({ fileType3: fileType3 }, () => { })
    }
    pullgolContent = (fileContent3) => {
        this.setState({ base64File3: fileContent3 }, () => { })
    }

    // fpna file details
    pullfpnafileName = (fileName) => {
        this.setState({ filename4: fileName }, () => { })
    }
    pullfpnafileType = (fileType) => {
        this.setState({ fileType4: fileType }, () => { })
    }
    pullfpnafileContent = (fileContent) => {
        this.setState({ base64File4: fileContent }, () => { })
    }

    pullClientName = (e) => {
        this.setState({ clientName: e }, () => { })
    }
    pullClientRole = (e) => {
        this.setState({ clientRole: e }, () => { })
    }
    pullClientSignOff = (e) => {
        this.setState({ clientSignOffDate: e }, () => { })
    }
    pullFpnaOhr = (e) => {
        this.setState({ fpnaOhr: e }, () => { })
    }
    pullFpnaName = (name) => {
        this.setState({ fpnaName: name }, () => { })
    }
    pullGolOhr = (e) => {
        this.setState({ golOhr: e }, () => { })
    }
    pullGolName = (name) => {
        this.setState({ golFullname: name }, () => { })
    }
    // function for FPNAGOL component ends here

    // AI First function starts here
    handleIsIdeaReplicableChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.IsIdeaReplicableSelectedOption = selectStyle(true);
        this.setState({ selectStyle: styleStateObj, IsIdeaReplicableSelectedOption: e })
    };

    handleSolutionFeasibleChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.solutionFeasibleSelectedOption = selectStyle(true);
        this.setState({ selectStyle: styleStateObj, solutionFeasibleSelectedOption: e })
    };
    handleSolutionComplexityChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.solutionComplexitySelectedOption = selectStyle(true);
        this.setState({ selectStyle: styleStateObj, solutionComplexitySelectedOption: e })
    };

    handleIsAIChange = (e) => {
        this.setState({ AIReason: "", AIBRD: "" }, () => { });
        let styleStateObj = this.state.selectStyle;
        styleStateObj.isAISelectedOption = selectStyle(true);
        this.setState({ selectStyle: styleStateObj, isAISelectedOption: e })
    };

    handleAIReasonChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.AIReason = selectStyle(true);
        this.setState({ selectStyle: styleStateObj, AIReason: e })
    }
    handleAIBRDChange = (e) => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.AIBRD = selectStyle(true);
        this.setState({ selectStyle: styleStateObj, AIBRD: e })
    }


    // LDT lead function starts here
    handleIsQBRChange = (e, receievedIndex) => {
        if (this.state.LDTLogs) {
            let LDTLogs = [...this.state.LDTLogs];
            LDTLogs[receievedIndex].IsQBR = e;
            LDTLogs[receievedIndex].UserName = this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName;
            LDTLogs[receievedIndex].UserOHR = this.sessionData.profile.oHRId;
            this.setState({
                LDTLogs: LDTLogs
            }, () => { });
        }
    }
    handleQBRDateChange = (e, receievedIndex) => {

        if (e !== null && e !== undefined) {
            if (new Date(e) > new Date()) {
                window.alert("QBR date cannot be greater than current date")
                return;
            } else {
                if (this.state.LDTLogs) {
                    let LDTLogs = [...this.state.LDTLogs];
                    LDTLogs[receievedIndex].QBRDate = e;
                    this.setState({
                        LDTLogs: LDTLogs
                    }, () => { });
                }
            }
        }
    }
    handleLDTApprovalCommentChange = (e, receievedIndex) => {
        if (this.state.LDTLogs) {
            let LDTLogs = [...this.state.LDTLogs];
            LDTLogs[receievedIndex].LDTComments = e;
            this.setState({
                LDTLogs: LDTLogs
            });
        }
    }
    toggleLDTApprovalCommentLogModal = () => {
        this.setState({ displayLDTCommentLog: true }, () => { })
    }
    formatDateLatest = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const day = currentDate.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    

    handleIdeaOwnerOhronCut = (event) => {
        if (event.target.value.length === 9) {
            this.handleIdeaOwnerChange()
        } else if (event.target.value.length === 0) {
            this.setState({ OwnerOHR: "", OwnerName: "" })
            return null
        }
        else {
            Toast.fail("Idea Owner OHR should be exactly of 9 digits", 3000, () => { })
            this.setState({ OwnerOHR: "", OwnerName: "" })
        }
    }

    handleIdeaOwnerChange = (event) => {
        let styleStateObj = this.state.selectStyle;
        var numbers = /^[0-9]+$/;
        if (event !== null && event !== undefined) {
            if (event.target.value.match(numbers) && event.target.value.length !== 0) {
                if (event.target.value.length === 9) {
                    styleStateObj.OwnerOHR = textBoxValidation(true);
                    let localIdeaOwnerOhr = event.target.value.trim();

                    if (this.state.blackBeltSelectedOption) {
                        if ((parseInt(localIdeaOwnerOhr) === parseInt(this.state.blackBeltSelectedOption.value))) {
                            Toast.fail('Idea Owner/Requester user cannot be the same as Mentor. Please select a different user.', 3000, () => {
                                return;
                            });
                            return;
                        }
                    }

                    if (this.state.mbbSelectedOption) {
                        if ((parseInt(localIdeaOwnerOhr) === parseInt(this.state.mbbSelectedOption.value))) {
                            Toast.fail('Idea Owner/Requester user cannot be the same as MBB. Please select a different user.', 3000, () => {
                                return;
                            });
                            return;
                        }
                    }

                    this.setState({ OwnerOHR: localIdeaOwnerOhr, selectStyle: styleStateObj, }, () => {
                        this.fetchSubmitIdeaOwnerOHRDetails(localIdeaOwnerOhr)
                    })
                }
                else {
                    this.setState({ OwnerOHR: "", OwnerName: "" })
                }
            } else {
                this.setState({ OwnerOHR: "", OwnerName: "" })
            }
        } else {
            this.setState({ OwnerOHR: "", OwnerName: "" })

        }
    }
    fetchSubmitIdeaOwnerOHRDetails = async (localIdeaOwnerOhr) => {
        Toast.loading("Fetching full name details. Please wait...", () => { });
        try {
            const param = {
                EntityType: "OHR",
                EntityName: localIdeaOwnerOhr
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,

                },
                body: JSON.stringify(param)
            };
            const response = await fetch(GET_METADATA, requestOptions);
            const data = await response.json();
            let requestByName = "";
            if (data.DNAUsers) {
                if (data.DNAUsers.Table1 && data.DNAUsers.Table1.length > 0) {
                    requestByName = data.DNAUsers.Table1[0].pg_username;
                }
            }

            if (requestByName === "" || requestByName === null || !requestByName) {
                Toast.fail("We could not find details based on the entered OHR. Please check and re-enter.", 5000, () => { });
                this.setState({ OwnerName: "" })
            }
            else {
                this.setState({ OwnerName: requestByName })
            }
            Toast.hide();
        } catch (error) {
            Toast.hide();
            Toast.fail('Please enter a valid OHR.', 5000, () => {
                console.log(JSON.stringify(error));
            });
            this.setState({ OwnerName: "" })
        }
    };



    handleCoderOHRAdd = () => {
        if (this.state.codersLoading) {
            console.log("Please wait, still adding the previous Coder ohr.");
            return;
        }
        if (this.state.CodersTable.length < 10) {
            let localOHR = this.state.individualCoderOHR
            if (localOHR.length === 9) {
                let OHRExist = this.state.CodersTable && this.state.CodersTable.some((item) => item.OHR === localOHR)
                if (OHRExist) {
                    Toast.info('Coder OHR already exist', 3000)
                    this.setState({ individualCoderOHR: "" })
                    return
                } else {
                    this.setState({
                        codersLoading: true
                    }, () => {
                        this.fetchSubmitCoderOHR(localOHR).finally(() => {
                            this.setState({ codersLoading: false })
                        })

                    })
                }
            } else {
                Toast.info("OHR should consist of 9 digits", 3000)
                return
            }
        } else {
            Toast.fail("Max 10 Coder OHRs are allowed.", 3000, () => { })
        }
    }

    handleCoderOHRKeyDown = (e) => {
        if (e.key === "Enter") {
            this.handleCoderOHRAdd()
        }
    }

    handleCoderOhrOnChange = (event) => {
        var numbers = /^[0-9]*$/;
        if (event !== null && event !== undefined) {
            if (event.target.value.match(numbers)) {
                let localCoderOHR = event.target.value.trim();
                this.setState({ individualCoderOHR: localCoderOHR }, () => {
                })
            }
        }
    }
    handleCoderOHRdelete = (index) => {
        if (window.confirm("Are you sure you want to delete the coder OHR ?")) {
            const { CodersTable } = this.state;
            const updatedItems = CodersTable.filter((_, i) => i !== index);
            this.setState({ CodersTable: updatedItems }, () => { });
        }
    }

    fetchSubmitCoderOHR = async (localCoderOHR) => {
        try {
            Toast.loading("Fetching Coder's full name, please wait...")
            const param = {
                EntityType: "OHR",
                EntityName: localCoderOHR
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,

                },
                body: JSON.stringify(param)
            };
            const response = await fetch(GET_METADATA, requestOptions);
            const data = await response.json();
            console.log(data);
            let requestByName = "";
            if (data.DNAUsers) {
                if (data.DNAUsers.Table1 && data.DNAUsers.Table1.length > 0) {
                    requestByName = data.DNAUsers.Table1[0].pg_username;
                }
            }
            Toast.hide();
            if (requestByName === "" || requestByName === null || !requestByName) {
                Toast.fail("We could not find Coder's full name details based on the entered OHR. Please check and re-enter.", 5000, () => { });
            } else {
                let newUser = {
                    OHRName: requestByName,
                    OHR: localCoderOHR
                }
                this.setState((prevState) => ({
                    CodersTable: [...prevState.CodersTable, newUser]
                })
                )
                console.log("coders ohr =>", this.state.CodersTable)
            }
            Toast.hide();
            this.setState({ individualCoderOHR: "" })

        } catch (error) {
            Toast.hide();
            Toast.fail('Please enter a valid Coder OHR', 5000, () => {
                console.log(JSON.stringify(error));
            });
            this.setState({ individualCoderOHR: "" })
        }
    };


    displayCoderSection = () => {
        let displayCoderSection = false;
        this.state.digitalProjectTypeList && this.state.digitalProjectTypeList.map((item) => {
            if (item.IsCoder === 1 || item.IsCoder === "1" || item.IsCoder === true || item.IsCoder === 'true') {
                if (this.state.digitalProjectTypeSelectedOptions?.label === item.DPType) {
                    displayCoderSection = true;
                }
            }
        })
        return displayCoderSection
    }


    checkifCoderTableUpdated = (prevArray, newArray) => {
        if (prevArray.length !== newArray.length) return true;
        let changed = false;
        prevArray.map((item) => {
            const found = newArray.some(newItem => newItem.OHR === item.OHR);
            if (!found) {
                changed = true;
            }
        });
        console.log("coders table has changed or no =>", changed)
        return changed;
    }


    handleFileDelete = (e) => {

        if (e.value === 0) {
            if (!this.state.ideaItem.GOLFileName || this.state.ideaItem.GOLFileName === "" || this.state.ideaItem.GOLFileName === null || this.state.ideaItem.GOLFileName === undefined) {
                window.alert("There is no record found of GOL file found in database table.")
                return false;
            }
        }
        if (e.value === 1) {
            if (!this.state.ideaItem.FPnAFileName || this.state.ideaItem.FPnAFileName === "" || this.state.ideaItem.FPnAFileName === null || this.state.ideaItem.FPnAFileName === undefined) {
                window.alert("There is no record found of FP&A file found in database table.")
                return false;
            }
        }



        if (window.confirm("Are you sure you want to delete this file ?")) {
            Toast.loading("Deeting the file...", () => { })
            return new Promise((resolve, reject) => {
                let query = '';
                if (e.value === 0) {
                    query = `Update Ideas set GOLFileName='',GOLFileType='' where IdeaId = ${this.props.location.state}; Update IdeaDocsBI set GolFile = '' where IdeaId = ${this.props.location.state};`
                }
                if (e.value === 1) {
                    query = `Update Ideas set FPnAFileName='',FPnAFileType='' where IdeaId = ${this.props.location.state}; Update IdeaDocsBI set FPnAFile = '' where IdeaId = ${this.props.location.state};`
                }

                let param = {
                    SaveType: "DeleteDocument",
                    IdeaId: this.state.ideaItem.IdeaId,
                    query: query,

                }
                console.log("Param =>", param);

                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": "Bearer " + this.accessToken,
                    },
                    body: JSON.stringify(param)
                };
                fetch(`${IDEA_ADMIN_UPDATE}`, requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        Toast.hide();
                        if (data.Message === "File Deleted") {
                            resolve();
                            Toast.success("File deleted succesfully.", 3000, () => {
                                window.location.reload()
                            })
                        }
                    })
                    .catch = (err) => {
                        reject(err);
                        console.log(JSON.stringify(err))
                        Toast.fail("failed to delete the file. Please try again.", 3000, () => { })
                    }
            })

        } else {
            return
        }
    }

    handleCommentChange=(e)=>{
        let styleStateObj = this.state.selectStyle;
        let nonWhiteSpace = e.replace(/^\s+|\s+$/gm, '');;
        if (nonWhiteSpace.length < 500) {
            styleStateObj.cancelComment = textBoxValidation(true);
            this.setState({
                cancelComment: e,
                selectStyle: styleStateObj,
            }, () => {
                this.state.cancelComment.replace(/'/g, "\\'");
            });
        } else {
            const trimmedValue = nonWhiteSpace.slice(0, 500);
            this.setState({
                cancelComment: trimmedValue,
                selectStyle: styleStateObj,
            }, () => {
                
            });
        }
    }



    cancelIdea = () => {
        console.log("this function is triggered")
        return new Promise((resolve, reject) => {

            if (this.state.cancelComment && this.state.cancelComment.length > 0) {
                if (window.confirm("Are you sure you want to cancel the idea ?")) {
                    Toast.loading("Cancellation is in process...", () => { });
                    let param = {};
                    param = {
                        SaveType: "CancelByAdmin",
                        OwnerOHR:this.state.ideaItem.OwnerOHR,
                        OwnerName:this.state.ideaItem.OwnerName,
                        
                        IdeaId: this.state.ideaItem.IdeaId,
                        LeanID:this.state.ideaItem.LeanID,
                        IdeaIDAlpha:this.state.ideaItem.IdeaIDAlpha,
                        IdeaName:this.state.ideaItem.IdeaName,
                       
                        ApprovalStatus: CANCEL,
                        WorkflowStatus: CANCEL,

                        UpdaterOHR: this.sessionData.profile.oHRId,
                        UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                        UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,

                        Comment: this.state.cancelComment,
                        FinalComment: this.state.cancelComment,
                        Role: "Admin",

                        IdeaName: this.state.ideaItem.IdeaName,
                        updaterAction: CANCEL,
                        Action:"Idea cancelled by Admin",
                        UpdaterRole: "Admin",
                    }

                    console.log('param =>', param)
                    const requestOptions = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + this.accessToken,
                        },
                        body: JSON.stringify(param),
                    };

                    fetch(`${IDEA_ADMIN_UPDATE}`, requestOptions)
                        .then(response => response.json())
                        .then(data => {
                            Toast.hide()
                            if (data.Message = "Cancelled Succesfully") {
                                Toast.success("Idea cancelled succesfully", 3000, () => { 
                                    resolve()
                                    window.location = "/view-all-ideas-page"
                                })
                            } else {
                                Toast.fail("Failed to cancel the idea. Please try again.", 5000, () => {
                                    reject();
                                })
                            }
                        })
                        .catch(err => {
                            Toast.fail("Failed to cancel the idea. Please try again.", 5000, () => { 
                                console.log(err)
                                reject()
                            })
                        })
                }

            } else {
                Toast.fail("Please provide a comment.", 3000, () => { })

                let styleStateObj = this.state.selectStyle;
                styleStateObj.cancelComment = textBoxValidation(false);
                this.setState({
                    cancelComment: "",
                    selectStyle: styleStateObj,
                }, () => {});
                return;
            }

        })


    }

    render() {
        return (
            <section className="u-clearfix u-section-1" id="sec-0f7f">
                <div className="u-clearfix u-sheet u-sheet-1" style={{ marginBottom: 20 }}>
                    <div className="u-align-left u-border-3 u-border-white u-container-style u-expanded-width u-group u-radius-10 u-shape-round u-white u-group-1">
                        <div className="u-container-layout u-container-layout-1">
                            <div className="">
                                <div className="" style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginRight: "56px"
                                }}>
                                    {
                                        (this.state.ideaItem.ApprovalStatus !== COMPLETE_STATUS && this.state.ideaItem.ApprovalStatus !== CANCEL && this.state.ideaItem.ApprovalStatus !== REJECTED)
                                        && (
                                            <button className='u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3' onClick={(e) => this.setState({showCancelIdeaModal:true}) } style={{marginRight:"15px"}}>Cancel Idea</button>
                                        )
                                    }
                                    
                                    <button className='u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3' onClick={(e) => this.setState({ showCommentLog: !this.state.showCommentLog })}>Comment Log</button>
                                    
                                </div>
                            </div>





                            <div className="text-left mt-4">
                                {this.state.showCancelIdeaModal ? (
                                    <>
                                        <div className="custom_modal">
                                            <div className="modal_body" style={{ width: "700px", overflow: "hidden" }}>
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <h3 className="modal_title">Cancel Idea </h3>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <button
                                                            type="button"
                                                            className="close text-right"
                                                            onClick={(e) =>
                                                                this.setState({ showCancelIdeaModal: false })
                                                            }
                                                        >
                                                            &times;
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="cancellation_alert_msg">
                                                    <div className="">
                                                        <label style={{ color: "red" }}>Note: Once cancelled you cannot have the project reinitiated. You will need to start the project from scratch.</label>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                                            <span className="u-text-black form-attribute">
                                                                <span style={{ color: "red" }}>*</span>
                                                                &nbsp;Comments
                                                                <span
                                                                    style={{
                                                                        fontWeight: "normal",
                                                                        fontSize: 12,
                                                                        fontStyle: "italic",
                                                                        color: "grey",
                                                                    }}
                                                                >
                                                                    {" "}
                                                                    (max. 500 chars)
                                                                </span>
                                                            </span>
                                                        </p>
                                                    </div>
                                                    
                                                </div>
                                                <div className="row" style={{ marginTop: 5 }}>
                                                    <div className="col-md-12">
                                                        <textarea
                                                            className="textarea-css form-attribute"
                                                            style={{
                                                                maxWidth: "100%",
                                                                border: "1px solid lightgrey",
                                                                ...this.state.selectStyle.cancelComment,
                                                            }}
                                                            rows={3}
                                                            cols={88}
                                                            placeholder="Please provide your comments on reason for cancellation."
                                                            onChange={(e) =>
                                                                this.handleCommentChange(e.target.value)
                                                            }
                                                            value={this.state.cancelComment}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="btn-group" style={{ marginTop: 10 }}>
                                                    <button
                                                        className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                                        onClick={this.cancelIdea}
                                                    >
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                                

                            </div>


                            {/* admin comment log */}
                            {
                                this.state.showCommentLog
                                    ?
                                    <div className="text-left mt-4">
                                        <div className="custom_modal">
                                            <div className="modal_body">
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <h3 className="modal_title">Comment Log</h3>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <button type="button" className="close text-right" onClick={(e) => this.setState({ showCommentLog: false, })}>&times;</button>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro", }}>
                                                        <label>Date & Time</label>
                                                    </div>
                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro", }}>
                                                        <label>OHR</label>
                                                    </div>
                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro", }}>
                                                        <label>Name</label>
                                                    </div>
                                                    <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro", }}>
                                                        <label>Role</label>
                                                    </div>
                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro", }} >
                                                        <label>Action</label>
                                                    </div>
                                                    <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro", }}>
                                                        <label> Comment</label>
                                                    </div>
                                                </div>
                                                {this.state.commentLog && this.state.commentLog.map(
                                                    (item, index) => {
                                                        return (
                                                            <div className="row" key={index}>
                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", }}>
                                                                    <label>
                                                                        {this.formatDateStringWithTime(new Date(item.CreatedDate))}
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", }}>
                                                                    <label>
                                                                        {item.UpdaterOHR}
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", }}>
                                                                    <label>
                                                                        {item.UpdaterName}
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey", }}>
                                                                    <label>
                                                                        {item.UpdaterRole}
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", }}>
                                                                    <label>
                                                                        {item.Action}
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey", }}>
                                                                    <label>
                                                                        {item.Comment ? item.Comment : "-"}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                    :
                                    null
                            }



                            <h4 style={{ textAlign: 'center', color: '#00AECF', fontFamily: 'Arial', fontSize: 22 }}>Edit idea : {this.state.ideaItem.IdeaIDAlpha ? this.state.ideaItem.IdeaIDAlpha : this.state.ideaItem.IdeaId} </h4>
                            <div className="u-align-left u-container-style u-expanded-width u-group u-shape-rectangle u-group-2">
                                <div className="u-container-layout u-container-layout-2" style={{ textAlign: 'center' }}>
                                    <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-3">
                                        <div className="u-container-layout u-container-layout-3">
                                            <p className="u-align-left u-text u-text-2" style={{ marginBottom: 15 }}>Owner details </p>
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <label className='admin_label_alignment'>Owner OHR</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <input
                                                        pattern="\d*"
                                                        maxLength="9"
                                                        defaultValue={this.state.OwnerOHR}
                                                        onChange={(e) => this.handleIdeaOwnerChange(e)}
                                                        onCut={(e) => this.handleIdeaOwnerOhronCut(e)}
                                                        className="textarea-css form-attribute hide_numeric_arrows" type="number"
                                                        onKeyDown={(evt) => (evt.key === '.' || evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                                        onWheel={(e) => e.target.blur()}
                                                        style={{ maxWidth: '100%', border: '1px solid lightgrey', ...this.state.selectStyle.OwnerOHR }}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: 15 }} />
                                            <div className="row">
                                                <div className="col-md-5"><label className='admin_label_alignment'>Owner Name</label> </div>
                                                <div className="col-md-6">
                                                    <input
                                                        className="form-input"
                                                        disabled type="text"
                                                        value={this.state.OwnerName}

                                                    />
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: -10 }} />
                                            <p className="u-align-left u-text u-text-7 u-text-custom-color-3" style={{ fontSize: 11, marginBottom: 10 }}>(If Idea was raised for someone else, their OHR ID is below)</p>
                                            <div className="row">
                                                <div className="col-md-5"><label className='admin_label_alignment'>Request For OHR</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" defaultValue={this.state.ideaItem.CreatorOHR} onChange={this.handleCreatorOHRChange} /></div>
                                            </div>
                                            <div style={{ marginBottom: 10 }} />
                                            <div className="row">
                                                <div className="col-md-5"><label className='admin_label_alignment'>Name</label> </div>
                                                <div className="col-md-6"><input className="form-input" disabled type="text" defaultValue={this.state.ideaItem.CreatorName} onChange={this.handleCreatorNameChange} /></div>
                                            </div>
                                            <div style={{ marginBottom: 10 }} />
                                            {
                                                (this.state.ideaItem.LeanID !== null && ((this.state.ideaItem.CertificationLevelName === "Lean" || this.state.ideaItem.CertificationLevelName === "YB") && this.state.ideaItem.TransformationLeverName !== "Digital")) ? (
                                                    <div className="row">
                                                        <div className="col-md-5"><label className='admin_label_alignment'>Project ID</label> </div>
                                                        <div className="col-md-6"><input className="form-input" disabled type="text" defaultValue={this.state.ideaItem.LeanID} /></div>
                                                    </div>
                                                ) : (
                                                    <div className="row">
                                                        <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: 12 }}>&nbsp;</label> </div>
                                                    </div>
                                                )
                                            }
                                            <div style={{ marginBottom: 10 }} />
                                        </div>
                                    </div>

                                    <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 255, marginLeft: -20 }}>&nbsp;</p>

                                    <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-4" style={{ marginTop: "-305px" }}>
                                        <div className="" style={{ display: "flex", marginTop: "30px" }}>
                                            <div className="u-container-style u-group u-shape-rectangle u-group-5">
                                                <div className="u-container-layout u-container-layout-5">
                                                    <p className="u-align-left u-text u-text-8" style={{ marginBottom: 15 }}>Account Details</p>
                                                    <div className="row">
                                                        <div className="col-md-5"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Account&nbsp;Name</label></div>
                                                        <div className="col-md-7">
                                                            <Select isSearchable={true} options={this.renderAccountOptions()} styles={this.state.selectStyle.accountSelectedOption} placeholder="Choose Account" value={this.state.accountSelectedOption} onChange={(e) => this.handleAccountNameChange(e)} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label className='admin_label_alignment'>&nbsp; Holding&nbsp;Account</label></div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled value={this.state.HoldingAccount} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Vertical</label></div>
                                                        <div className="col-md-7">
                                                            <Select isSearchable={true} value={this.state.verticalSelectedOption} options={this.renderVerticalOptions(this.state.verticalSelectedOption)} styles={this.state.selectStyle.verticalSelectedOption} placeholder="Choose Vertical" onChange={(e) => this.handleVerticalChange(e)} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Industry Vertical</label></div>
                                                        <div className="col-md-7">
                                                            <Select isSearchable={true} value={this.state.subVerticalSelectedOption} options={this.renderSubVerticalOptions()} styles={this.state.selectStyle.subVerticalSelectedOption} placeholder="Choose Industry&nbsp;Vertical" onChange={(e) => this.handleSubVerticalChange(e)} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />

                                                    {/* units and Segments starts here */}
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                            <label className="form-attribute admin_label_alignment">&nbsp; Segment</label>
                                                        </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled value={this.state.Segment} style={{ fontWeight: 'normal !important' }} />
                                                        </div>
                                                    </div>

                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                            <label className="form-attribute admin_label_alignment">&nbsp; Unit</label>
                                                        </div>
                                                        <div className="col-md-7">
                                                            <input className="form-input" disabled name="Unit" value={this.state.Unit ? this.state.Unit : ""} style={{ fontWeight: 'normal !important' }} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    {/* units and Segments ends here */}


                                                    <div className="row">
                                                        <div className="col-md-5"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Campaign Name</label></div>
                                                        <div className="col-md-7">
                                                            <Select
                                                                isSearchable={true}
                                                                value={this.state.campaignSelectedOption}
                                                                options={this.renderCampaignOptions()}
                                                                styles={this.state.selectStyle.campaignSelectedOption}
                                                                placeholder="Choose Campaign"
                                                                onChange={(e) => this.handleCampaignChange(e)}
                                                            />
                                                        </div>
                                                        <div className="">
                                                            <div className="campaign_modal_bulb campaign_tool_tip">
                                                                <img
                                                                    src={require("../assets/images/question_mark_2.png")}
                                                                    alt=""
                                                                    className=""
                                                                />
                                                                {
                                                                    this.state.campaignInsight
                                                                        ?
                                                                        <>
                                                                            <span className="my_tooltiptext">{this.state.campaignInsight}</span>
                                                                        </>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />


                                                    {(this.state.displaySubCampaign || this.state.campaignSelectedOption?.label === "Gen AI") && (
                                                        <>
                                                            <div className="row" style={{ marginBottom: 15 }}>
                                                                <div className="col-md-5">
                                                                    <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                                                        <span style={{ color: "red" }}>*&nbsp;</span>
                                                                        {
                                                                            this.state.campaignSelectedOption?.label === "Gen AI"
                                                                                ?
                                                                                "Gen AI Theme"
                                                                                :
                                                                                "Sub Campaign"
                                                                        }
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <Select
                                                                        isSearchable={true}
                                                                        options={this.renderSubCampaignOptions()}
                                                                        styles={this.state.selectStyle.subCampaignOption}
                                                                        placeholder="Choose Sub Campaign"
                                                                        value={this.state.subCampaignOption}
                                                                        onChange={this.handleSubCampaignChange}
                                                                    />
                                                                </div>
                                                            </div>

                                                        </>
                                                    )}

                                                    {
                                                        this.state.displayParentAlpha && this.state.displayParentAlpha.length > 0 && this.state.displayParentAlpha !== null && this.state.displayParentAlpha !== undefined && this.state.displayParentAlpha !== ""
                                                            ?
                                                            <>
                                                                <div className="row" style={{ marginBottom: 15 }}>
                                                                    <div className="col-md-5">
                                                                        <label className='admin_label_alignment'>Parent ID</label>
                                                                    </div>
                                                                    <div className="col-md-7">
                                                                        <input className="form-input" disabled placeholder="Choose Parent ID" value={this.state.displayParentAlpha} />
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            null
                                                    }


                                                    {
                                                        this.state.campaignSelectedOption && this.state.campaignSelectedOption.label === AIFIRST
                                                            ?
                                                            <>
                                                                <div className="row" style={{ marginBottom: "15px" }}>
                                                                    <div className="col-md-5">
                                                                        <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                                                            <i>AI First Sample Ideas</i>
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-7">
                                                                        <div className="ai_first_doc_link ai_first_doc_red_highlight">
                                                                            <a
                                                                                className="ldt-list1"
                                                                                href={AI_DOC_LINK}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                                style={{ textAlign: "left", fontSize: 16, color: "red" }}
                                                                            >Document Link </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    this.state.isAISelectedOption?.label === "Yes"
                                                                        ?
                                                                        <>
                                                                            <div style={{ marginBottom: 20 }} />
                                                                            <div className="row d_flex_align_items_center">
                                                                                <div className="col-md-5">
                                                                                    <label className='admin_label_alignment'>AI Recommendation</label>
                                                                                </div>
                                                                                <div className="col-md-7">
                                                                                    <Select
                                                                                        styles={this.state.selectStyle.isAISelectedOption}
                                                                                        value={this.state.isAISelectedOption}
                                                                                        placeholder="Please choose value"
                                                                                        options={YESORNO}
                                                                                        onChange={(e) => this.handleIsAIChange(e)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        null
                                                                }

                                                                {
                                                                    this.state.isAISelectedOption?.label === "Yes"
                                                                        ?
                                                                        <>
                                                                            <div style={{ marginBottom: 20 }} />
                                                                            <div className="row d_flex_align_items_center">
                                                                                <div className="col-md-5">
                                                                                    <label className='admin_label_alignment'>
                                                                                        AI First BRD
                                                                                    </label>
                                                                                </div>
                                                                                <div className="col-md-7">
                                                                                    <textarea
                                                                                        value={this.state.AIBRD}
                                                                                        placeholder="Please provide value"
                                                                                        className="textarea-css form-attribute"
                                                                                        onChange={(e) => this.handleAIBRDChange(e.target.value)}
                                                                                        rows={4}
                                                                                        cols={80}
                                                                                        style={{
                                                                                            maxWidth: "100%",
                                                                                            border: "1px solid lightgrey",
                                                                                            ...this.state.selectStyle.AIBRD,
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        null
                                                                }

                                                            </>
                                                            :
                                                            null
                                                    }

                                                </div>
                                            </div>
                                            <div className="u-container-layout u-container-layout-6">
                                                <div style={{ marginTop: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Country</label></div>
                                                    <div className="col-md-7">
                                                        <Select isSearchable={true} value={this.state.countrySelectedOption} options={this.renderCountryOptions(this.state.countrySelectedOption)} styles={this.state.selectStyle.countrySelectedOption} placeholder="Choose Country" onChange={(e) => this.handleCountryChange(e)} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Region</label></div>
                                                    <div className="col-md-7">
                                                        <Select isSearchable={true} value={this.state.regionSelectedOption} options={this.renderRegionOptions(this.state.regionSelectedOption)} styles={this.state.selectStyle.regionSelectedOption} placeholder="Choose Region" onChange={(e) => this.handleRegionChange(e)} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Sub-Region</label></div>
                                                    <div className="col-md-7">
                                                        <Select isSearchable={true} value={this.state.subRegionSelectedOption} options={this.renderSubRegionOptions(this.state.subRegionSelectedOption)} styles={this.state.selectStyle.subRegionSelectedOption} placeholder="Choose Sub-Region" onChange={(e) => this.handleSubRegionChange(e)} />
                                                    </div>
                                                </div>
                                                <div style={{ marginBottom: 15 }} />
                                                <div className="row">
                                                    <div className="col-md-5"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Blackbelt&nbsp;Name</label></div>
                                                    <div className="col-md-7">
                                                        <Select isSearchable={true} value={this.state.blackBeltSelectedOption} options={this.renderBlackBeltOptions(this.state.blackBeltSelectedOption)} styles={this.state.selectStyle.blackBeltSelectedOption} placeholder="Choose Blackbelt" onChange={(e) => this.handleBBChange(e)} />
                                                    </div>
                                                </div>
                                                {
                                                    this.state.ideaItem.MBBName || (this.state.ideaItem.WorkflowStatus === "Approve" || this.state.ideaItem.WorkflowStatus === "Approved")
                                                        ?

                                                        <div className="row" style={{ marginTop: 15 }}>
                                                            <div className="col-md-5">
                                                                <label className='admin_label_alignment'><span className='admin_asterisk'>* </span>MBB</label>
                                                            </div>
                                                            <div className="col-md-7">
                                                                <Select
                                                                    isSearchable={true}
                                                                    value={this.state.mbbSelectedOption}
                                                                    options={this.renderMBBOptions()}
                                                                    styles={this.state.selectStyle.mbbSelectedOption}
                                                                    placeholder="Choose MBB"
                                                                    onChange={(e) => this.handleMBBChange(e)} />
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }

                                                {
                                                    this.state.campaignSelectedOption && this.state.campaignSelectedOption.label === AIFIRST && this.state.isAISelectedOption?.label === "Yes"
                                                        ?
                                                        <>
                                                            <div style={{ marginBottom: 20 }} />
                                                            <div className="row d_flex_align_items_center">
                                                                <div className="col-md-12">
                                                                    <label className='admin_label_alignment'>
                                                                        AI First Reason
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <textarea
                                                                        value={this.state.AIReason}
                                                                        placeholder="Please provide value"
                                                                        className="textarea-css form-attribute"
                                                                        onChange={(e) => this.handleAIReasonChange(e.target.value)}
                                                                        rows={4}
                                                                        cols={80}
                                                                        style={{
                                                                            marginTop: "10px",
                                                                            width: "100%",
                                                                            resize: "none",
                                                                            border: "1px solid lightgrey",
                                                                            ...this.state.selectStyle.AIReason,
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        null
                                                }


                                                <div style={{ marginBottom: 15 }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div id="idea1" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ paddingTop: 15, borderTop: '1px solid lightgrey' }}>
                                        <div className="u-container-layout u-container-layout-7">
                                            <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                                <div className="u-container-layout u-container-layout-8">
                                                    <p id="idea1title" className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Idea details</p>
                                                    <div className="row">
                                                        <div className="col-md-4"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Service Line</label> </div>
                                                        <div className="col-md-8">
                                                            <Select isSearchable={true} options={this.renderServiceLineOptions()} styles={this.state.selectStyle.serviceLineSelectedOption} placeholder="Choose Service Line" value={this.state.serviceLineSelectedOption} onChange={(e) => this.handleServiceLineChange(e)} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <div className="row">
                                                        <div className="col-md-4"><label className='admin_label_alignment'><span className='admin_asterisk'>* </span>Sub Service Line</label> </div>
                                                        <div className="col-md-8">
                                                            <Select isSearchable={true} options={this.renderSubServiceLineOptions()} styles={this.state.selectStyle.subServiceLineSelectedOption} placeholder="Choose Sub Service Line" value={this.state.subServiceLineSelectedOption} onChange={(e) => this.handleSubServiceLineChange(e)} />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 15 }} />
                                                    <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                                        <span className="u-text-black form-attribute"><span className='admin_asterisk'>* </span>What is the Problem ?</span>&nbsp;
                                                    </p>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <textarea
                                                                placeholder='Problem statement here'
                                                                className="textarea-css form-attribute"
                                                                rows={6} cols={80}
                                                                style={{ maxWidth: '100%', border: '1px solid lightgrey', ...this.state.selectStyle.Problem }}
                                                                value={this.state.Problem}
                                                                onChange={(e) => this.handleProblemChange(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 10 }}>&nbsp;</p>
                                            <div className="u-container-style u-group u-shape-rectangle u-group-9">
                                                <div className="u-container-layout u-container-layout-9" style={{ marginTop: 4 }}>
                                                    <div className="row">
                                                        <div className="col-md-3"><label className='admin_label_alignment'>Idea Name</label> </div>
                                                        <div className="col-md-9" style={{ alignItems: 'flex-start' }}>
                                                            <input className="form-input" disabled type="text" value={this.state.ideaItem.IdeaName} placeholder="Eg: Cash flow improvement through process restructuring" />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: 66 }} />
                                                    <p className="u-align-left u-text u-text-custom-color-4 u-text-25" style={{ width: "208px" }}>
                                                        <span className="u-text-black form-attribute"><span className='admin_asterisk'>* </span>How to resolve the problem</span>&nbsp;
                                                    </p>
                                                    <div className="row" style={{ marginBottom: 15 }}>
                                                        <div className="col-md-12">
                                                            <textarea
                                                                placeholder='Solution statement here'
                                                                className="textarea-css form-attribute"
                                                                rows={6} cols={80}
                                                                style={{ maxWidth: '100%', border: '1px solid lightgrey', ...this.state.selectStyle.Solution }}
                                                                value={this.state.Solution}
                                                                onChange={(event) => this.handleSolutionChange(event.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{ marginTop: 15 }}>
                                                <div className="col-md-5"><span className="form-attribute">Are you trying to replicate an existing Idea ?</span>

                                                </div>
                                                <div className="col-md-4">
                                                    <label className="switch">
                                                        <input type="checkbox" value={this.state.NewOrReplicatedIdea} checked={this.state.NewOrReplicatedIdea ? true : false} onChange={() => this.showHideDiv()} />
                                                        <span className="slider round" value={this.state.NewOrReplicatedIdea} />
                                                    </label>
                                                </div>
                                            </div>

                                            {
                                                this.state.NewOrReplicatedIdea && (
                                                    <>
                                                        <div className="col-md-8" style={{ marginBottom: 15, width: "100%" }} />
                                                        <div className="row">
                                                            <div className="col-md-5"><span className="form-attribute">
                                                                {/* <span className='admin_asterisk'>*&nbsp;</span> */}
                                                                Provide the ID of the executed Idea which you want to replicate ?</span>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <input className="textarea-css form-attribute" type="text" value={this.state.ReplicationProjectId} style={{ border: '1px solid lightgrey', ...this.state.selectStyle.ReplicationProjectId }} onChange={event => { this.handleReplicationIdChange(event.target.value) }} onKeyPress={event => {
                                                                    if (event.key === 'Enter') {
                                                                        this.validateReplicationId();
                                                                    }
                                                                }} />
                                                            </div>
                                                            <div className="col-md-1"><i className="fa fa-check-square-o" style={{ marginTop: 5, color: '#FF555F', fontSize: 24 }} onClick={event => { this.validateReplicationId() }} /></div>
                                                            <div className="col-md-8" style={{ marginBottom: 15 }} />
                                                        </div>
                                                    </>
                                                )
                                            }
                                            <div className="col-md-8" style={{ marginBottom: 15 }} />
                                        </div>
                                    </div>

                                    {
                                        (this.state.ideaItem.WorkflowStatus) && (
                                            <>
                                                <div style={{ borderBottom: '1px solid lightgrey', marginBottom: 15 }} />

                                                {
                                                    ((this.state.ideaItem.WorkflowStatus === "Approve" || this.state.ideaItem.WorkflowStatus === "Approved")) && (
                                                        <div id="Potential Impact" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                                            <div className="u-container-layout u-container-layout-7" style={{ display: "flex" }}>
                                                                <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                                                    <div className="u-container-layout u-container-layout-8">
                                                                        <p id="Potential Impact" className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Additional details</p>
                                                                        <div className="row">
                                                                            <div className="col-md-6">
                                                                                <label className="form-attribute">
                                                                                    <span className='admin_asterisk'>*&nbsp;</span>
                                                                                    LDT Lead Name</label>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <Select
                                                                                    isSearchable={true}
                                                                                    value={this.state.LDTLeadSelectedOption}
                                                                                    options={this.renderLeadOptions()}
                                                                                    styles={this.state.selectStyle.LDTLeadName}
                                                                                    placeholder="Choose LDT Lead"
                                                                                    onChange={(e) => this.handleLDTLeadOptionChange(e)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />

                                                                        {this.state.campaignSelectedOption && this.state.campaignSelectedOption.label === AIFIRST ? (
                                                                            <>
                                                                                <div style={{ marginBottom: 15 }} />
                                                                                <div className="row d_flex_align_items_center">
                                                                                    <div className="col-md-6">
                                                                                        <label className='admin_label_alignment'>
                                                                                            Is the solution feasible ?
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <Select
                                                                                            styles={this.state.selectStyle.solutionFeasibleSelectedOption}
                                                                                            options={YESORNO}
                                                                                            value={this.state.solutionFeasibleSelectedOption}
                                                                                            onChange={(e) => this.handleSolutionFeasibleChange(e)}
                                                                                            placeholder="Please Choose"
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <div style={{ marginBottom: 15 }} />
                                                                                <div className="row d_flex_align_items_center">
                                                                                    <div className="col-md-6">
                                                                                        <label className='admin_label_alignment'>Solution Complexity</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <Select
                                                                                            styles={this.state.selectStyle.solutionComplexitySelectedOption}
                                                                                            options={SOLUTIONCOMPLEXITY}
                                                                                            value={this.state.solutionComplexitySelectedOption}
                                                                                            onChange={(e) => this.handleSolutionComplexityChange(e)}
                                                                                            placeholder="Please Choose"
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <div style={{ marginBottom: 15 }} />
                                                                                <div className="row d_flex_align_items_center">
                                                                                    <div className="col-md-6">
                                                                                        <label className='admin_label_alignment'>
                                                                                            Is the Idea replicable
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <Select
                                                                                            options={YESORNO}
                                                                                            value={this.state.IsIdeaReplicableSelectedOption}
                                                                                            styles={this.state.selectStyle.IsIdeaReplicableSelectedOption}
                                                                                            onChange={this.handleIsIdeaReplicableChange}
                                                                                            placeholder="Choose replicability Index"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{ marginBottom: 20 }} />
                                                                            </>
                                                                        ) : null}



                                                                        {
                                                                            this.state.NewOrReplicatedIdea && (
                                                                                <div className="row">
                                                                                    <div className="col-md-10">
                                                                                        <label className='admin_label_alignment'>Have you verified the replication id and confirm this to be replication project?</label>
                                                                                    </div>
                                                                                    <div className="col-md-2">
                                                                                        <label className="switch">
                                                                                            <input disabled type="checkbox" checked={this.state.ideaItem.IsReplicationVerified} readOnly />
                                                                                            <span className="slider round" />
                                                                                        </label>
                                                                                    </div>
                                                                                    <div style={{ marginBottom: 45 }} />
                                                                                </div>
                                                                            )
                                                                        }

                                                                        {
                                                                            this.displayCoderSection() && (
                                                                                <div className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ marginTop: 40 }}>
                                                                                    <div className="u-container-layout u-container-layout-7" style={{ paddingTop: "0px" }}>
                                                                                        <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Coder Section</p>
                                                                                        <div>
                                                                                            <div className="row">
                                                                                                <div className="col-md-8">
                                                                                                    <input type="text" onChange={this.handleCoderOhrOnChange} onKeyDown={this.state.CodersTable.length <= 10 ? this.handleCoderOHRKeyDown : null} value={this.state.individualCoderOHR} placeholder="Enter coder's OHR" className="textarea-css form-attribute hide_numeric_arrows" />
                                                                                                </div>
                                                                                                <div className="col-md-4">
                                                                                                    <button onClick={this.handleCoderOHRAdd} disabled={this.state.CodersTable.length >= 10} className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3">Add</button>
                                                                                                </div>
                                                                                            </div>
                                                                                            {
                                                                                                this.state.CodersTable.length !== 0 &&
                                                                                                <div className="VD_Summary" >
                                                                                                    <div className="row mt-3">
                                                                                                        <div className="col-md-7 col-xs-4 VD_Summary_table_header">
                                                                                                            <div className=""><label>Coder Name</label></div>
                                                                                                        </div>
                                                                                                        <div className="col-md-3 col-xs-4 VD_Summary_table_header">
                                                                                                            <div><label>Coder OHR</label></div>
                                                                                                        </div>
                                                                                                        <div className="col-md-2 col-xs-4 VD_Summary_table_header">
                                                                                                            <div style={{ display: 'grid', justifyContent: 'center' }}>
                                                                                                                <label>Delete</label>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {this.state.CodersTable && this.state.CodersTable.map((item, index) => {
                                                                                                        return (
                                                                                                            <>
                                                                                                                <div className="" key={index}>
                                                                                                                    <div className="row">
                                                                                                                        <div className="col-md-7 col-xs-4 VD_Summary_table_row">
                                                                                                                            <div style={{ marginTop: '2.5px' }}>
                                                                                                                                <label>{item.OHRName}</label>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <div className="col-md-3   col-xs-4 VD_Summary_table_row">
                                                                                                                            <div style={{ marginTop: '2.5px' }}>
                                                                                                                                <label>{item.OHR}</label>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <div className="col-md-2 col-xs-4 VD_Summary_table_row">
                                                                                                                            <div style={{ display: 'grid', justifyContent: 'center', marginTop: '2.5px' }} >
                                                                                                                                <button
                                                                                                                                    title='Delete'
                                                                                                                                    className="btn btn-danger cursor-pointer btn-sm u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-2 p-3"
                                                                                                                                    style={{ width: '23px', marginTop: '1.5px' }}
                                                                                                                                    onClick={() => { this.handleCoderOHRdelete(index) }}
                                                                                                                                ><i className="fa fa-trash" aria-hidden="true"></i></button>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        )
                                                                                                    })}
                                                                                                </div>
                                                                                            }

                                                                                        </div>
                                                                                        <div className="col-md-12" style={{ marginBottom: "15px" }} />
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className="u-container-style u-group u-shape-rectangle u-group-9" style={{ marginTop: "0px" }}>
                                                                    <div className="u-container-layout u-container-layout-9" >
                                                                        <div className="row">
                                                                            <div className="col-md-5">
                                                                                <label className="form-attribute">
                                                                                    <span className='admin_asterisk'>*&nbsp;</span>
                                                                                    Certification Level</label>
                                                                            </div>
                                                                            <div className="col-md-7">
                                                                                <Select
                                                                                    options={this.renderCertLevelsOptions()}
                                                                                    styles={this.state.selectStyle.certLevelsSelectedOption}
                                                                                    value={this.state.certLevelsSelectedOption}
                                                                                    onChange={this.handleCertLevelChange}
                                                                                    placeholder="Choose Certification Level"
                                                                                    isDisabled={this.state.ideaItem.CertificationLevelName === "GB" ? true : false}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                        <div className="row">
                                                                            <div className="col-md-5">
                                                                                <label className="form-attribute">
                                                                                    <span className='admin_asterisk'>*&nbsp;</span>
                                                                                    Transformation Lever
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-7">
                                                                                <Select
                                                                                    options={this.renderTransLeversOptions()}
                                                                                    value={this.state.transSelectedOption}
                                                                                    styles={this.state.selectStyle.transSelectedOption}
                                                                                    onChange={(e) => this.handleTransLeversChange(e)}
                                                                                    placeholder="Choose Transformation Lever"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />

                                                                        {
                                                                            this.state.transSelectedOption?.label === "Digital"
                                                                                ?
                                                                                <div className="row" style={{ marginBottom: 15 }}>
                                                                                    <div className="col-md-5">
                                                                                        <label className='admin_label_alignment'>
                                                                                            <span className='admin_asterisk'>*&nbsp;</span>
                                                                                            Digital Project Type</label></div>
                                                                                    <div className="col-md-7">
                                                                                        <Select
                                                                                            options={this.renderDigitalProjectTypeOptions()}
                                                                                            value={this.state.digitalProjectTypeSelectedOptions}
                                                                                            onChange={this.handleDigitalProjectTypeChange}
                                                                                            placeholder="Choose Project Type"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                null

                                                                        }

                                                                        {
                                                                            this.state.certLevelsSelectedOption?.label === "GB" && (
                                                                                <div className="row" style={{ marginBottom: 15 }}>
                                                                                    <div className="col-md-5">
                                                                                        <label className="form-attribute">
                                                                                            <span className='admin_asterisk'>*&nbsp;</span>
                                                                                            Work Type</label>
                                                                                    </div>
                                                                                    <div className="col-md-7">
                                                                                        {
                                                                                            this.state.transSelectedOption?.label === "Continuous Improvement" ? (
                                                                                                <Select
                                                                                                    options={this.renderCertWorkTypeOptions(this.state.certLevelsSelectedOption)}
                                                                                                    styles={this.state.selectStyle.certWorkTypeSelectedOption}
                                                                                                    value={this.state.certWorkTypeSelectedOption}
                                                                                                    onChange={this.handleCertWorkTypeChange}
                                                                                                    placeholder="Choose Work Type"
                                                                                                />
                                                                                            ) : (
                                                                                                <input
                                                                                                    className="form-input"
                                                                                                    disabled
                                                                                                    type='text'
                                                                                                    name="worktype"
                                                                                                    value="GB ProDG"
                                                                                                />
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                </div>

                                                                            )
                                                                        }





                                                                        <div className="">
                                                                            <div className="row">
                                                                                <div className="col-md-5">
                                                                                    <span className="form-attribute">
                                                                                        <span className='admin_asterisk'>*&nbsp;</span>
                                                                                        AI Classification
                                                                                    </span>
                                                                                </div>
                                                                                <div className="col-md-7">
                                                                                    <Select
                                                                                        isSearchable={false}
                                                                                        options={this.renderAIClassificationList()}
                                                                                        value={this.state.aiClassificationListSelectedOption}
                                                                                        styles={this.state.selectStyle.aiClassificationListSelectedOption}
                                                                                        onChange={(e) => this.handleAIClassificationChange(e)}
                                                                                        placeholder="Choose AI Classification"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div style={{ marginBottom: 15 }} />
                                                                        </div>



                                                                        <div className="row">
                                                                            <div className="col-md-5">
                                                                                <label className="form-attribute">
                                                                                    <span className='admin_asterisk'>*&nbsp;</span>
                                                                                    Tools/Methodology Used
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-7">
                                                                                <Select
                                                                                    isSearchable={true}
                                                                                    isMulti={true}
                                                                                    options={this.renderMethodologyOptions()}
                                                                                    value={this.state.methodologySelectedOptions}
                                                                                    styles={this.state.selectStyle.methodologySelectedOptions}
                                                                                    onChange={this.handleMethodologyChange}
                                                                                    placeholder="Choose Methodologies"
                                                                                    title={this.state.methodologySelectedOptions}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />


                                                                        <div className="row">
                                                                            <div className="col-md-5">
                                                                                <span className="form-attribute">
                                                                                    <span >&nbsp;&nbsp;</span>
                                                                                    Other tools</span>
                                                                            </div>
                                                                            <div className="col-md-7">
                                                                                <textarea
                                                                                    rows='3'
                                                                                    className="textarea-css form-attribute"
                                                                                    style={{ border: "1px solid lightgrey", ...this.state.selectStyle.OtherTools, width: "100%" }}
                                                                                    placeholder='Provide other tools'
                                                                                    value={this.state.OtherTools}
                                                                                    type="text"
                                                                                    title={this.state.OtherTools ? this.state.OtherTools : ""}
                                                                                    onChange={(e) => this.handleOtherToolsChange(e.target.value)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginBottom: 15 }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </>
                                        )
                                    }


                                    {
                                        this.state.ideaItem.VDType && (
                                            <div >
                                                <div id="Potential Impact" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7" style={{ borderBottom: '1px solid lightgrey', marginBottom: 10 }}>
                                                    <div className="u-container-layout" style={{ borderTop: "1px solid lightgray", padding: "35px 0px" }}>
                                                        <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                                            <div className="u-container-layout u-container-layout-8">
                                                                <p id="Potential Impact" className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Final additional details</p>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <span className="form-attribute"><span style={{ color: 'red' }}> *</span> Final Impact (# of FTE)</span>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            className="form-input"
                                                                            disabled
                                                                            type="number"
                                                                            value={this.state.FinalImpactFTE}
                                                                            placeholder={0}
                                                                            max={10}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div style={{ marginBottom: 15 }} />
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <span className="form-attribute"><span style={{ color: 'red' }}>*</span> Final Impact ($)</span>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            className="form-input"
                                                                            disabled
                                                                            type="number"
                                                                            value={this.state.FinalImpactDollar}
                                                                            placeholder={0.0}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div style={{ marginBottom: 5 }} />
                                                                <div className="u-align-left u-text u-text-custom-color-3" style={{ fontSize: 11, fontStyle: 'italic' }}>(If Final Impact $ is greater than 250K OR Final FTE number is greater than 10, please review thoroughly)</div>
                                                                <div style={{ marginTop: 5, marginBottom: 15 }} />
                                                                <div className="row">
                                                                    <div className="col-md-5">
                                                                        <span className="form-attribute"><span style={{ color: 'red' }}>*</span> Is it a Zero Impact Project</span>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <label className="switch">
                                                                            <input type="checkbox" id="isZeroImpactProject" checked={this.state.impactOptionSelected?.label === NO_VD ? true : false} readOnly />
                                                                            <span className="slider round" />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div style={{ marginBottom: 22 }} />
                                                            </div>
                                                        </div>
                                                        <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 22 }}>&nbsp;</p>
                                                        <div className="u-container-style u-group u-shape-rectangle u-group-9">
                                                            <div className="u-container-layout u-container-layout-9" style={{ marginTop: 90, marginBottom: 36 }}>
                                                                <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: '-100px' }}>&nbsp;</p>
                                                                <div className="row">
                                                                    <div className="col-md-5">
                                                                        <span className="form-attribute">&nbsp; Best in Class</span>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <label className="switch best_in_class_slider">
                                                                            <input type="checkbox" id="isReplicationIdeaBtn" checked={this.state.IsBestInClass} value={this.state.IsBestInClass} onClick={this.showHideBestInClass} />
                                                                            <span className="slider round" />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="row" style={{ marginTop: 15 }}>
                                                                    <div className="col-md-5">
                                                                        <label className="form-attribute" >&nbsp; Replicability Index</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <Select
                                                                            options={REPLICABILITYOPTIONS}
                                                                            value={this.state.replicaIndex}
                                                                            styles={this.state.selectStyle.replicaIndex}
                                                                            placeholder="Choose replicabilty index"
                                                                            onChange={this.replicaIndexChangeHandler}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div style={{ marginBottom: 15 }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                {
                                                    this.state.ideaItem.CertificationLevelName === "Lean" && this.state.ideaItem.IdeaId
                                                        ?
                                                        <>

                                                            {
                                                                (this.state.impactOptionSelected?.label === VD_TO_CLIENT_PLUS_GENPACT || this.state.impactOptionSelected?.label === VD_TO_GENPACT)
                                                                    ?
                                                                    <div className="row" style={{ marginTop: "30px", borderBottom: "1px solid lightgrey", padding: "0px 0px 26px 0px" }}>
                                                                        <div className="col-md-5">
                                                                            <p id="Upload" className="u-align-left u-text u-text-2" style={{ marginBottom: "10px" }}>Delete Documents</p>
                                                                            <div className="">
                                                                                <div className="row">
                                                                                    <div className="col-md-5" style={{ display: "flex", justifyContent: "flex-start" }}>
                                                                                        <label className='admin_label_alignment'>Delete Document</label></div>
                                                                                    <div className="col-md-7">
                                                                                        <Select
                                                                                            options={this.state.files_can_be_deleted}
                                                                                            placeholder="Choose file to be deleted"
                                                                                            onChange={(e) => this.handleFileDelete(e)}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                        <div className="col-md-7"></div>
                                                                    </div>
                                                                    :
                                                                    null

                                                            }

                                                            {
                                                                this.state.ideaItem.IdeaId && this.state.ideaItem.CertificationLevelName === "Lean" && this.state.businessImpactMasterList
                                                                    ?
                                                                    <>
                                                                        <ValueDelivery
                                                                            IdeaData={this.state.ideaItem}
                                                                            vdForComponent={this.state.vdForComponent}

                                                                            BIMasterDataVerseNew={this.state.businessImpactMasterList}
                                                                            func={this.pull_data}
                                                                            viewIdea={false}
                                                                            vdType={this.handleVDTypeChange}
                                                                            IdeaId={this.state.ideaItem.IdeaId}
                                                                            fetchMonetizationFileDetails={this.pull_file_data}
                                                                            bbMonetizationTotal={this.pull_monetizedTotal}
                                                                            monetizableProject={this.pull_monetizableProject}
                                                                            monetizableStatus={this.pull_monetizableStatus}
                                                                            fetchFPAOHRforIncreaseInRevenue={this.fetchFPAOHRforIncreaseInRevenue}
                                                                            bbMonetizationApproval={false}
                                                                            postFpnaValid={
                                                                                this.state.ideaItem.MonetizationState === null || this.state.ideaItem.MonetizationState === undefined ? false
                                                                                    : this.state.ideaItem.MonetizationState.trim() === "" || this.state.ideaItem.MonetizationState === null ? false
                                                                                        : true
                                                                            }
                                                                            fetchMonetizationSowID={this.pull_monetization_sowId}
                                                                            fetchDeletedBIRows={this.remove_bi_data_after_delete}
                                                                            fetchMonetizationFpnaOhr={this.pull_monetization_fpna_ohr}
                                                                            fetchMonetizationFpnaName={this.pull_monetization_fpna_name}
                                                                            fetchMonetizationGOLName={this.pullMonetizationGOLName}
                                                                            fetchMonetizationGOLOhr={this.pullMonetizationGOLOhr}
                                                                            fetchCategoryNotListed={this.pullCategoryNotListed}

                                                                            fetchPPTDeck={this.pullPPTDeck}
                                                                            fetchClientDocName={this.pullClientDocName}
                                                                            fetchClientDocType={this.pullClientDocType}
                                                                            fetchClientDocContent={this.pullClientDocContent}
                                                                            fetchGolDocName={this.pullgolFileName}
                                                                            fetchGolDocType={this.pullgolFileType}
                                                                            fetchGolDocContent={this.pullgolContent}
                                                                            fetchfpnaDocName={this.pullfpnafileName}
                                                                            fetchfpnaDocType={this.pullfpnafileType}
                                                                            fetchfpnaDocContent={this.pullfpnafileContent}
                                                                            fetchClientName={this.pullClientName}
                                                                            fetchClientRole={this.pullClientRole}
                                                                            fetchClientSignOffDate={this.pullClientSignOff}
                                                                            fetchFpnaName={this.pullFpnaName}
                                                                            fetchGolName={this.pullGolName}
                                                                            fetchFpnaOhr={this.pullFpnaOhr}
                                                                            fetchGolOhr={this.pullGolOhr}
                                                                            fetchFileDetails={this.pull_fileDetails}

                                                                        />
                                                                        {
                                                                            this.state.impactOptionSelected && this.state.impactOptionSelected.label === NO_VD
                                                                                ?
                                                                                <>

                                                                                </>
                                                                                :
                                                                                <div className="" style={{ borderBottom: "1px solid lightgrey" }} />
                                                                        }
                                                                    </>
                                                                    :
                                                                    null

                                                            }

                                                        </>
                                                        :
                                                        null
                                                }


                                                {
                                                    this.state.showHrefModal
                                                        ?
                                                        <>
                                                            <div className="custom_modal href_modal">
                                                                <div className="modal_body href_modal_body">
                                                                    <div className="href_modal_dialog">
                                                                        <p>To add a new category please raise a Helpmate ticket, Click here to View SOP</p>
                                                                        <div className="href_modal_body_buttons">
                                                                            <div className="btn-group href_modal_body_buttons">
                                                                                <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"><a href="https://genpactonline.sharepoint.com/:b:/r/sites/LeanDigitalTransformation/Documents/KM%20Page%20-%202021/Certification%20Guidelines,%20SOPs%20%26%20Handbooks/Certification%20guidelines,%20SOPs%20%26%20Handbooks/Systems%20%26%20Tools/Helpmate-Data%20Related%20Request/ProGEAR%20Value%20Delivery%20Category%20Addition%20SOP.pdf?csf=1&web=1&e=5kKbFg" style={{ color: "#FFF" }} target="_blank">Click Here</a></button>
                                                                                <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6" onClick={(e) => this.setState({ showHrefModal: false })}>Cancel</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </>
                                                        :
                                                        null
                                                }
                                            </div>
                                        )
                                    }
                                    {
                                        (this.state.ideaItem.CertificationLevelName === 'Lean' && this.state.ideaItem.ApprovalStatus === COMPLETE_STATUS) && (
                                            <>
                                                <div style={{ marginBottom: 20, marginTop: 10 }} />
                                                <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                                    <div className="u-container-layout" style={{ padding: "34px 30px 15px 30px" }}>
                                                        <div className="row">
                                                            <div className="col-md-4"><span className="form-attribute">Six Sigma</span> </div>
                                                            <div className="col-md-8">
                                                                <label className="switch">
                                                                    <input type="checkbox" checked={this.state.IsSharedToSixSigma} onChange={() => this.showHideIsSharedToSixSigma()} />
                                                                    <span className="slider round" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }

                                    
                          

                                    
                                    


                                    {/* .....LDT Lead Approval starts here........ */}
                                    {
                                        this.state.ideaItem.ApprovalStatus === COMPLETE_STATUS
                                            ?
                                            <>
                                                <div className="">
                                                    <div className="" style={{ borderTop: "1px solid lightgrey", paddingRight: "30px", paddingTop: "10px" }}>
                                                        <div className="">
                                                            <div className="row">
                                                                <div className="col-md-8">
                                                                    <h3 className="idea_form_header">Client QBR</h3>
                                                                </div>
                                                                <div className="col-md-4" >
                                                                    <div className="project_lead_comment_log_button" style={{}}>
                                                                        <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.toggleLDTApprovalCommentLogModal()}>LDT Lead Approval Log</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="">
                                                                {
                                                                    this.state.displayLDTCommentLog
                                                                        ?
                                                                        <>
                                                                            {
                                                                                this.state.LDTLogs
                                                                                    ?
                                                                                    <>
                                                                                        <div className="custom_modal ldt_lead_approval_modal admin_ldt_approval_modal">
                                                                                            <div className="modal_body">
                                                                                                <div className="modal_title_block">
                                                                                                    <div className="row d_flex_align_items_center">
                                                                                                        <div className="col-md-8">
                                                                                                            <h3 className="modal_title">
                                                                                                                LDT Lead Approval Log
                                                                                                            </h3>
                                                                                                        </div>
                                                                                                        <div className="col-md-4">
                                                                                                            <div className=" ldt_approval_modal_btn_block">
                                                                                                                <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={this.UpdateIdea}>Update</button>
                                                                                                                <button
                                                                                                                    type="button"
                                                                                                                    className="close text-right"
                                                                                                                    onClick={(e) =>
                                                                                                                        this.setState({
                                                                                                                            displayLDTCommentLog: false,
                                                                                                                        })
                                                                                                                    }
                                                                                                                >
                                                                                                                    &times;
                                                                                                                </button>
                                                                                                            </div>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>


                                                                                                <div className="qc_responsive_comment_log">
                                                                                                    <div className="table table-responsive table-bordered">
                                                                                                        <thead className="text-center">
                                                                                                            <tr>

                                                                                                                <th className="qcHeaderbg qcVDHeader LDTHeaderFullWidthOne">
                                                                                                                    <label
                                                                                                                        style={{
                                                                                                                            fontWeight: 100,
                                                                                                                            verticalAlign: "bottom",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Project demonstrated in Client QBR
                                                                                                                    </label>
                                                                                                                </th>
                                                                                                                <th className="qcHeaderbg qcVDHeader LDTHeaderFullWidthTwo">
                                                                                                                    <label
                                                                                                                        style={{
                                                                                                                            fontWeight: 100,
                                                                                                                            verticalAlign: "bottom",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        QBR Submitted Date
                                                                                                                    </label>
                                                                                                                </th>
                                                                                                                <th
                                                                                                                    className="qcHeaderbg"
                                                                                                                    style={{
                                                                                                                        minWidth: "400px",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <label
                                                                                                                        style={{
                                                                                                                            fontWeight: 100,
                                                                                                                            verticalAlign: "bottom",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Comment
                                                                                                                    </label>
                                                                                                                </th>
                                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                                    <label
                                                                                                                        style={{
                                                                                                                            fontWeight: 100,
                                                                                                                            verticalAlign: "bottom",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Name
                                                                                                                    </label>
                                                                                                                </th>

                                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                                    <label
                                                                                                                        style={{
                                                                                                                            fontWeight: 100,
                                                                                                                            verticalAlign: "bottom",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Role
                                                                                                                    </label>
                                                                                                                </th>
                                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                                    <label
                                                                                                                        style={{
                                                                                                                            fontWeight: 100,
                                                                                                                            verticalAlign: "bottom",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        OHR
                                                                                                                    </label>
                                                                                                                </th>

                                                                                                                <th className="qcHeaderbg qcVDHeader">
                                                                                                                    <label
                                                                                                                        style={{
                                                                                                                            fontWeight: 100,
                                                                                                                            verticalAlign: "bottom",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Date & Time
                                                                                                                    </label>
                                                                                                                </th>
                                                                                                            </tr>
                                                                                                        </thead>
                                                                                                        <tbody style={{ textAlign: "left" }}>
                                                                                                            {this.state.LDTLogs.map(
                                                                                                                (item, index) => {
                                                                                                                    return (
                                                                                                                        <tr key={index}>
                                                                                                                            <td style={{ textAlign: "left" }}>
                                                                                                                                <Select value={item.IsQBR} options={YESORNO} onChange={(e) => this.handleIsQBRChange(e, index)} />
                                                                                                                            </td>
                                                                                                                            <td>
                                                                                                                                <input
                                                                                                                                    defaultValue={this.formatDateLatest(new Date(item.QBRDate))}
                                                                                                                                    className="textarea-css form-attribute" type="date"
                                                                                                                                    onChange={(e) => this.handleQBRDateChange(e.target.value, index)}
                                                                                                                                />
                                                                                                                            </td>
                                                                                                                            <td>
                                                                                                                                <input
                                                                                                                                    value={item.LDTComments}
                                                                                                                                    type="text"
                                                                                                                                    className="textarea-css form-attribute"
                                                                                                                                    onChange={(e) => this.handleLDTApprovalCommentChange(e.target.value, index)}
                                                                                                                                />
                                                                                                                            </td>
                                                                                                                            <td>
                                                                                                                                <label
                                                                                                                                    style={{
                                                                                                                                        lineheight: 2,
                                                                                                                                        verticalAlign:
                                                                                                                                            "bottom",
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {item.UserName}
                                                                                                                                </label>
                                                                                                                            </td>
                                                                                                                            <td>
                                                                                                                                <label
                                                                                                                                    style={{
                                                                                                                                        lineheight: 2,
                                                                                                                                        verticalAlign:
                                                                                                                                            "bottom",
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    LDT Lead
                                                                                                                                </label>
                                                                                                                            </td>

                                                                                                                            <td>
                                                                                                                                <label
                                                                                                                                    style={{
                                                                                                                                        lineheight: 2,
                                                                                                                                        verticalAlign:
                                                                                                                                            "bottom",
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {item.UserOHR}
                                                                                                                                </label>
                                                                                                                            </td>




                                                                                                                            <td>
                                                                                                                                <label
                                                                                                                                    style={{
                                                                                                                                        lineheight: 2,
                                                                                                                                        verticalAlign:
                                                                                                                                            "bottom",
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {this.formatDateStringWithTime(
                                                                                                                                        new Date(
                                                                                                                                            item.CreatedDate
                                                                                                                                        )
                                                                                                                                    )}
                                                                                                                                </label>
                                                                                                                            </td>
                                                                                                                        </tr>
                                                                                                                    );
                                                                                                                }
                                                                                                            )}
                                                                                                        </tbody>
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                    :
                                                                                    null

                                                                            }


                                                                        </>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            null
                                    }

                                    {/* .......LDT lead approval ends here...... */}



                                    {this.state.QCOHR ? (
                                        <>
                                            <div
                                                id="Approval Status"
                                                className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                                            >
                                                <div
                                                    className="u-container-layout u-container-layout-7"
                                                    style={{
                                                        margin: "10px 0px",
                                                        borderBottom: "1px solid lightgray",
                                                        borderTop: "1px solid lightgray",
                                                        paddingTop: "35px",
                                                    }}
                                                >
                                                    <p
                                                        className="u-align-left u-text u-text-2"
                                                        style={{ marginBottom: 10 }}
                                                    >
                                                        QC Approval details
                                                    </p>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <span className="form-attribute">
                                                                Approval Status
                                                            </span>{" "}
                                                        </div>
                                                        <div className="col-md-3">
                                                            <input
                                                                className="form-input"
                                                                disabled
                                                                name="finalapprovalstatus"
                                                                value={this.state.ideaItem.ApprovalStatus}
                                                            />
                                                        </div>
                                                    </div>

                                                    {
                                                        this.state.ideaItem.QCName ?
                                                            <>
                                                                <div className="row" style={{ marginTop: 15 }}>
                                                                    <div className="col-md-2">
                                                                        <span className="form-attribute">
                                                                            QC Approver
                                                                        </span>{" "}
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <input
                                                                            className="form-input disabled_input"
                                                                            disabled
                                                                            value={this.state.ideaItem.QCName ? this.state.ideaItem.QCName : ""}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            null
                                                    }




                                                    <div className="row" style={{ marginTop: 15 }}>
                                                        <div className="col-md-5">
                                                            <label
                                                                style={{
                                                                    verticalAlign: "bottom",
                                                                    marginBottom: -5,
                                                                }}
                                                            >
                                                                Approval Comments
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="col-md-2"
                                                            style={{ marginLeft: 20 }}
                                                        >
                                                            <button
                                                                className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                                                onClick={(e) =>
                                                                    this.setState({
                                                                        qcCommentLog:
                                                                            !this.state.qcCommentLog,
                                                                    })
                                                                }
                                                            >
                                                                Comment Log
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="row" style={{ marginTop: 5 }}>
                                                        <div className="col-md-12">
                                                            <textarea
                                                                className="form-input"
                                                                disabled
                                                                rows={3}
                                                                cols={88}
                                                                style={{
                                                                    maxWidth: "100%",
                                                                    border: "1px solid lightgrey",
                                                                }}
                                                                name="Comments"
                                                                value={this.state.lastQCCOmment}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="text-left mt-4">
                                                        {this.state.qcCommentLog &&
                                                            this.state.qcComments ? (
                                                            <>
                                                                <div className="custom_modal">
                                                                    <div className="modal_body">
                                                                        <div className="row">
                                                                            <div className="col-md-8">
                                                                                <h3 className="modal_title">
                                                                                    QC Comment Log
                                                                                </h3>
                                                                            </div>
                                                                            <div className="col-md-4">
                                                                                <button
                                                                                    type="button"
                                                                                    className="close text-right"
                                                                                    onClick={(e) =>
                                                                                        this.setState({
                                                                                            qcCommentLog: false,
                                                                                        })
                                                                                    }
                                                                                >
                                                                                    &times;
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        <div className="qc_responsive_comment_log">
                                                                            <div className="table table-responsive table-bordered">
                                                                                <thead className="text-center">
                                                                                    <tr>
                                                                                        <th className="qcHeaderbg qcVDHeader">
                                                                                            <label className="admin_qc_log_labels">Date & Time</label>
                                                                                        </th>
                                                                                        <th className="qcHeaderbg qcVDHeader">
                                                                                            <label className="admin_qc_log_labels">OHR</label>
                                                                                        </th>
                                                                                        <th className="qcHeaderbg qcVDHeader">
                                                                                            <label className="admin_qc_log_labels">Name</label>
                                                                                        </th>
                                                                                        <th className="qcHeaderbg qcVDHeader">
                                                                                            <label className="admin_qc_log_labels">Role</label>
                                                                                        </th>
                                                                                        <th className="qcHeaderbg qcVDHeader">
                                                                                            <label className="admin_qc_log_labels">Action</label>
                                                                                        </th>
                                                                                        <th className="qcHeaderbg" style={{ minWidth: "250px", }}>
                                                                                            <label className="admin_qc_log_labels">Comment</label>
                                                                                        </th>
                                                                                        <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthOne">
                                                                                            <label className="admin_qc_log_labels">Is the impact correctly tagged to Genpact or Client ?</label>
                                                                                        </th>
                                                                                        <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthTwo">
                                                                                            <label className="admin_qc_log_labels">Has the Value Delivery been correctly categorized ?</label>
                                                                                        </th>
                                                                                        <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthThree">
                                                                                            <label className="admin_qc_log_labels">Has the Value Delivery been computed correctly ?</label>
                                                                                        </th>
                                                                                        <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthFour">
                                                                                            <label className="admin_qc_log_labels">Do the value delivery approvals (applicable as per the value playbook) clearly articulate what improved and for which time-period ?</label>
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {this.state.qcComments.map(
                                                                                        (item, index) => {
                                                                                            return (
                                                                                                <tr key={index}>
                                                                                                    <td>
                                                                                                        <label className='admin_qc_log_label_values'>
                                                                                                            {this.formatDateStringWithTime(new Date(item.CreatedDate))}
                                                                                                        </label>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <label className='admin_qc_log_label_values'>
                                                                                                            {item.UpdaterOHR}
                                                                                                        </label>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <label className='admin_qc_log_label_values'>
                                                                                                            {item.UpdaterName}
                                                                                                        </label>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <label className='admin_qc_log_label_values'>
                                                                                                            {item.UpdaterRole}
                                                                                                        </label>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <label className='admin_qc_log_label_values'>
                                                                                                            {item.UpdaterAction ? item.UpdaterAction : item.ApprovalStatus === "Documents Uploaded" ? "Send Back" : item.WorkflowStatus === "Rejected" || item.WorkflowStatus === "Reject" || item.ApprovalStatus === "Reject" || item.ApprovalStatus === "Rejected" ? "Rejected " : item.Action === "Idea was Rework - QC" ? "Rework" : "Approved"}
                                                                                                        </label>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <label className='admin_qc_log_label_values'>
                                                                                                            {item.Comment !== "" ? item.Comment : "-"}
                                                                                                        </label>
                                                                                                    </td>
                                                                                                    {this.state.qcCommentsWithVD && this.state.qcCommentsWithVD.length > 0 ? (
                                                                                                        <>
                                                                                                            {this.state.qcCommentsWithVD.map((pg_item) => {
                                                                                                                if (Number(pg_item.ProjectTeamID) === item.TrackId) {
                                                                                                                    const replacedJSONString = pg_item.AuditDataJSON ? pg_item.AuditDataJSON.replace(/'/g, '"') : "";
                                                                                                                    const auditData = JSON.parse(replacedJSONString)
                                                                                                                    return (
                                                                                                                        <>
                                                                                                                            <td>
                                                                                                                                <label className='admin_qc_log_label_values'>
                                                                                                                                    {auditData.pg_isvdimpacttagged ? auditData.pg_isvdimpacttagged : "-"}
                                                                                                                                </label>
                                                                                                                            </td>
                                                                                                                            <td>
                                                                                                                                <label className='admin_qc_log_label_values'>
                                                                                                                                    {auditData.pg_isvdcategorized ? auditData.pg_isvdcategorized : "-"}
                                                                                                                                </label>
                                                                                                                            </td>
                                                                                                                            <td>
                                                                                                                                <label className='admin_qc_log_label_values'>
                                                                                                                                    {auditData.pg_isvdcomputed ? auditData.pg_isvdcomputed : "-"}
                                                                                                                                </label>
                                                                                                                            </td>
                                                                                                                            <td>
                                                                                                                                <label className='admin_qc_log_label_values' >
                                                                                                                                    {auditData.pg_isvdclientsignoff ? auditData.pg_isvdclientsignoff : "-"}
                                                                                                                                </label>
                                                                                                                            </td>
                                                                                                                        </>
                                                                                                                    );
                                                                                                                }
                                                                                                            }
                                                                                                            )}
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <td>
                                                                                                                <label className='admin_qc_log_label_values'>-</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label className='admin_qc_log_label_values'>-</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label className='admin_qc_log_label_values'>-</label>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <label className='admin_qc_log_label_values'>-</label>
                                                                                                            </td>
                                                                                                        </>
                                                                                                    )}
                                                                                                </tr>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                                </tbody>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="gol_fields_block" style={{ borderBottom: "0px", paddingRight: "30px" }} >
                                                <p className="u-align-left u-text u-text-2" style={{ margin: "10px 0px 20px" }}> Quality Check Details</p>
                                                <div className="row u-align-left">
                                                    <div className="col-md-5">
                                                        <div className="row">
                                                            <div className="col-md-9 gol_field_div">
                                                                <span className="form-attribute">
                                                                    Is the impact correctly tagged to Genpact or Client ?
                                                                </span>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <Select
                                                                    styles={this.state.selectStyle.qcImpactTagChangeSelected}
                                                                    options={YESORNO}
                                                                    onChange={(e) => this.handleQCImpactTagChange(e)}
                                                                    value={this.state.qcImpactTagChangeSelected}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />

                                                        <div className="row">
                                                            <div className="col-md-9 gol_field_div">
                                                                <span className="form-attribute">
                                                                    Has the value delivered been correctly categorized ?
                                                                </span>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <Select
                                                                    styles={this.state.selectStyle.qcDeliveryCategorizedSelect}
                                                                    options={YESORNO}
                                                                    onChange={(e) => this.handleDeliveryCategorizedChange(e)}
                                                                    value={this.state.qcDeliveryCategorizedSelect}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div style={{ marginBottom: 15 }} />

                                                        <div className="row">
                                                            <div className="col-md-5 gol_field_div">
                                                                <span className="form-attribute">
                                                                    Project Reviewed By
                                                                </span>
                                                            </div>
                                                            <div className="col-md-7">
                                                                <input disabled className="form-input" value={this.state.ideaItem.QCName} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-5">
                                                        <div className="row">
                                                            <div className="col-md-9 gol_field_div">
                                                                <span className="form-attribute">
                                                                    Has the value delivered been computed correctly ?
                                                                </span>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <Select
                                                                    styles={this.state.selectStyle.deliveryComputedCorrectlySelected}
                                                                    options={YESORNO}
                                                                    onChange={(e) => this.handledeliveryComputedCorrectlySelectedChange(e)}
                                                                    value={this.state.deliveryComputedCorrectlySelected}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />

                                                        <div className="row">
                                                            <div className="col-md-9 gol_field_div">
                                                                <span className="form-attribute">
                                                                    Do the value delivery approvals (applicable as per the value playbook) clearly articulate what improved and for which time-period?
                                                                </span>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <Select
                                                                    styles={this.state.selectStyle.signOffDeliverySelected}
                                                                    options={YESORNO}
                                                                    onChange={(e) => this.handleSignOffDeliveryChange(e)}
                                                                    value={this.state.signOffDeliverySelected}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : null}


                                    <div style={{ borderBottom: '1px solid lightgrey', marginTop: 10, marginBottom: 25 }} />
                                    <div className="btn-group">
                                        <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={this.mainUpdateFunction}>Update</button>
                                        <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6" onClick={this.cancelEvent}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default AdminEditPage
